/* BPF Slim app.js (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  var drawer = document.querySelector('[data-nav-drawer]');
  var scrim = document.querySelector('[data-nav-scrim]');
  var toggle = document.querySelector('[data-nav-toggle]');
  var closeBtn = document.querySelector('[data-nav-close]');

  function openNav() {
    drawer.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 220);
  }
  if (drawer && toggle) {
    toggle.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (scrim) scrim.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeNav();
    });
  }

  /* ---- Ambient video (hero + page accents): honor save-data / reduced motion ---- */
  var ambientVideos = document.querySelectorAll('.hero-video, [data-accent-video]');
  if (ambientVideos.length) {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(conn && conn.saveData);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ambientVideos.forEach(function (v) {
      if (saveData || reducedMotion) {
        // stop the download; the poster stays visible
        v.removeAttribute('autoplay');
        v.pause();
        v.querySelectorAll('source').forEach(function (s) { s.remove(); });
        v.load();
        if (v.classList.contains('hero-video')) v.style.display = 'none';
      } else {
        // some browsers ignore autoplay on metadata-preload video; nudge it
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var box = (minus || plus).closest('[data-qty]');
    var input = box.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '1', 10);
    input.value = plus ? val + 1 : Math.max(min, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Cart: auto-submit on qty change ---- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 400);
    });
  }

  /* ---- Collection sort ---- */
  var sortSel = document.querySelector('[data-sort-by]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- Product gallery ---- */
  var mainImg = document.querySelector('[data-gallery-main]');
  var thumbs = document.querySelector('[data-gallery-thumbs]');
  if (mainImg && thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.thumb');
      if (!btn) return;
      mainImg.src = btn.dataset.full;
      mainImg.removeAttribute('srcset');
      thumbs.querySelectorAll('.thumb').forEach(function (el) { el.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  }

  /* ---- Variant select: price / sku / stock / ATC / affirm ---- */
  var variantSel = document.querySelector('[data-variant-select]');
  if (variantSel) {
    variantSel.addEventListener('change', function () {
      var opt = variantSel.options[variantSel.selectedIndex];
      var price = parseInt(opt.dataset.price, 10);
      var compare = parseInt(opt.dataset.compare, 10) || 0;
      var available = opt.dataset.available === 'true';
      var money = function (cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      var block = document.querySelector('[data-price-block]');
      if (block) {
        var html = '<div class="price price-big' + (compare > price ? ' on-sale' : '') + '">';
        html += '<span class="price-now">' + money(price) + '</span>';
        if (compare > price) {
          html += '<s class="price-was">' + money(compare) + '</s>';
          html += '<span class="price-save">Save ' + money(compare - price).replace(/\.00$/, '') + '</span>';
        }
        html += '</div>';
        block.innerHTML = html;
      }

      var sku = document.querySelector('[data-sku]');
      if (sku && opt.dataset.sku) sku.textContent = opt.dataset.sku;

      var stock = document.querySelector('[data-stock]');
      if (stock) {
        stock.className = 'stock-flag ' + (available ? 'in-stock' : 'soldout');
        stock.textContent = available ? 'In stock' : 'Sold out';
      }

      var atc = document.querySelector('[data-atc]');
      if (atc) {
        atc.disabled = !available;
        atc.textContent = available ? 'Add to cart' : 'Sold out';
      }

      var affirmEl = document.querySelector('.affirm-as-low-as');
      if (affirmEl) {
        affirmEl.setAttribute('data-amount', price);
        if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh();
      }
    });
  }

  /* ---- Description: tag the Notices list for callout styling ---- */
  var desc = document.querySelector('[data-product-description]');
  if (desc) {
    desc.querySelectorAll('h3, h2').forEach(function (h) {
      var text = h.textContent.trim().toLowerCase();
      if (text === 'notices' || text === 'notice') {
        var next = h.nextElementSibling;
        if (next && next.tagName === 'UL') next.classList.add('notices-list');
      }
    });
  }
})();

/* ==========================================================================
   Shop by Vehicle: header mega-menu, drawer accordion, picker band.

   One data source for all three: assets/vehicle-nav.json, fetched once per page
   and shared through a cached promise. Contract:
     { generatedAt, makes: [ { name, tag, handle, families: [ { name, tag,
       handle, generations: [ { code, display, tag, handle, yearMin, yearMax } ]
     } ] } ], universal?: { tag, title, handle } }
   generations and universal are optional: the UI renders them only when present.
   ========================================================================== */
(function () {
  'use strict';

  var srcEl = document.querySelector('[data-nav-src]');
  if (!srcEl || !window.fetch) return;
  var SRC = srcEl.getAttribute('data-nav-src');
  var BASE = (srcEl.getAttribute('data-collections-base') || '/collections').replace(/\/$/, '');

  var pending = null;
  function loadNav() {
    if (!pending) {
      pending = fetchJson(SRC, 'vehicle-nav');
    }
    return pending;
  }

  function fetchJson(src, label) {
    return fetch(src, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(label + ' ' + r.status);
      return r.json();
    });
  }

  /* Product type tags are now present throughout the catalog, so category
     subcategories compose their type tag with any active vehicle tag. */
  var TYPE_TAGS_LIVE = true;

  /* URL scheme. Menu and picker links belong on the DEDICATED vehicle
     collections (/collections/subaru-outback-parts): the canonical per-vehicle
     surface, one collection per vehicle, which settles small enough to carry the
     native Storefront filters that a tag filter on the oversized /collections/all
     cannot. (Those collections are a single vehicle-tag rule now; the Universal
     rule was removed, so they no longer fold universal parts in.) When the
     collections are not resolvable on the storefront, snippets/header.liquid
     probes for them and sets data-url-mode, so links fall back to native tag
     filtering and switch over with no code change once they land. */
  var URL_MODE = srcEl.getAttribute('data-url-mode') === 'collection' ? 'collection' : 'tag';

  function handleize(tag) {
    return String(tag).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function url(entry) {
    if (!entry) return BASE;
    if (URL_MODE === 'collection' && entry.handle) return BASE + '/' + entry.handle;
    if (entry.tag) return BASE + '/all/' + handleize(entry.tag);
    return entry.handle ? BASE + '/' + entry.handle : BASE;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function link(cls, text, entry) {
    var a = el('a', cls, text);
    a.href = url(entry);
    return a;
  }
  function genLabel(g) { return g.display || g.code || ''; }

  /* The JSON ranks makes by product mass, which reads as random in a menu.
     Every list a shopper sees is sorted A-Z; the mass order stays in the file. */
  function alphabetical(list) {
    return list
      .map(function (item, i) { return { i: i, name: item.name, item: item }; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, 'en', { numeric: true, sensitivity: 'base' }); });
  }
  function sortedByName(list) {
    return alphabetical(list).map(function (m) { return m.item; });
  }

  /* Shared surface for the garage and instant refinement modules further down.
     One cached nav promise, one set of helpers, so nothing fetches twice. */
  window.BPF = window.BPF || {};
  window.BPF.loadNav = loadNav;
  window.BPF.handleize = handleize;
  window.BPF.collectionsBase = BASE;
  window.BPF.vehicleUrl = url;
  window.BPF.vehicleUrlMode = URL_MODE;
  window.BPF.alphabetical = alphabetical;
  window.BPF.genLabel = genLabel;

  /* ---- desktop mega-menu ---- */
  var mega = document.querySelector('[data-mega]');
  var trigger = mega && mega.querySelector('[data-mega-trigger]');
  var panel = mega && mega.querySelector('[data-mega-panel]');

  if (mega && trigger && panel) {
    var railBox = panel.querySelector('[data-mega-makes]');
    var pane = panel.querySelector('[data-mega-pane]');
    var paneTitle = panel.querySelector('[data-mega-pane-title]');
    var paneAll = panel.querySelector('[data-mega-all]');
    var paneAllLabel = panel.querySelector('[data-mega-all-label]');
    var famBox = panel.querySelector('[data-mega-fams]');
    var uniBox = panel.querySelector('[data-mega-universal]');
    var uniLink = panel.querySelector('[data-mega-universal-link]');

    var navData = null;
    var railMakes = [];     // makes in the order the rail shows them (A-Z)
    var tabs = [];
    var activeIndex = -1;
    var isOpen = false;
    var failed = false;

    /* Makes are picked by click only. Hovering a row never changes the active
       make or the model panel, so travelling from a make to its models cannot
       swap the panel out from under the pointer. Keyboard: arrows move focus,
       Enter or Space activates (manual activation, which is what aria-selected
       promises here). */

    function renderFamilies(mk) {
      famBox.textContent = '';
      mk.families.forEach(function (f) {
        var item = el('div', 'mega-fam');
        item.appendChild(link('mega-fam-link', f.name, f));
        if (f.generations && f.generations.length) {
          item.classList.add('has-gens');
          var list = el('ul', 'mega-gens');
          f.generations.forEach(function (g) {
            var li = document.createElement('li');
            li.appendChild(link('mega-gen-link', genLabel(g), g));
            list.appendChild(li);
          });
          item.appendChild(list);
        }
        famBox.appendChild(item);
      });
    }

    function activate(i, focusTab) {
      if (!railMakes[i]) return;
      if (i !== activeIndex) {
        var mk = railMakes[i];
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        activeIndex = i;
        paneTitle.textContent = mk.name + ' models';
        paneAll.href = url(mk);
        paneAllLabel.textContent = 'All ' + mk.name + ' parts';
        pane.setAttribute('aria-labelledby', tabs[i].id);
        renderFamilies(mk);
      }
      if (focusTab) tabs[i].focus();
    }

    function build(d) {
      navData = d;
      railMakes = sortedByName(d.makes);
      railBox.textContent = '';
      tabs = railMakes.map(function (mk, i) {
        var b = el('button', 'mega-make', mk.name);
        b.type = 'button';
        b.id = 'mega-make-' + i;
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('aria-controls', 'mega-vehicles-pane');
        b.tabIndex = -1;
        b.addEventListener('click', function () { activate(i, true); });
        railBox.appendChild(b);
        return b;
      });
      if (d.universal && d.universal.handle) {
        uniLink.href = url(d.universal);
        uniLink.textContent = d.universal.title || 'Universal parts';
        uniBox.hidden = false;
      }
      activate(0, false);
    }

    function open(focusIn) {
      if (isOpen || failed) return;
      isOpen = true;
      panel.hidden = false;
      mega.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      loadNav().then(function (d) {
        if (!tabs.length) build(d);
        if (focusIn && isOpen && tabs.length) tabs[activeIndex].focus();
      }).catch(function () {
        // no data, no menu: the trigger goes back to being a plain link
        failed = true;
        close(false);
      });
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
      mega.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }

    trigger.addEventListener('click', function (e) {
      // modified clicks and the no-data fallback keep the link behaviour
      if (failed || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (isOpen) close(false);
      else open(e.detail === 0);
    });

    // hover: open on the nav item, close on any exit from the header row, so the
    // dead space between the trigger and the panel is not a trap
    var masthead = mega.closest('.masthead');
    mega.addEventListener('mouseenter', function () { open(false); });
    if (masthead) {
      masthead.addEventListener('mouseleave', function () { close(false); });
      masthead.querySelectorAll('.main-nav > ul > li').forEach(function (li) {
        if (li !== mega) li.addEventListener('mouseenter', function () { close(false); });
      });
    }

    // prefetch on intent, so the first open has data ready
    trigger.addEventListener('mouseenter', function () { loadNav().catch(function () {}); });
    trigger.addEventListener('focus', function () { loadNav().catch(function () {}); });

    function focusTab(i) {
      if (!tabs[i]) return;
      tabs.forEach(function (t, n) { t.tabIndex = n === i ? 0 : -1; });
      tabs[i].focus();
    }

    railBox.addEventListener('keydown', function (e) {
      var keys = { ArrowDown: 1, ArrowUp: -1, ArrowRight: 1, ArrowLeft: -1 };
      var here = tabs.indexOf(document.activeElement);
      if (here < 0) here = activeIndex;
      if (e.key in keys) {
        e.preventDefault();
        focusTab(Math.min(tabs.length - 1, Math.max(0, here + keys[e.key])));
      } else if (e.key === 'Home') {
        e.preventDefault();
        focusTab(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        focusTab(tabs.length - 1);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close(true);
    });
    document.addEventListener('click', function (e) {
      if (isOpen && !mega.contains(e.target)) close(false);
    });
  }

  /* ---- mobile drawer accordion ---- */
  var acc = document.querySelector('[data-drawer-vehicles]');
  if (acc) {
    var accBtn = acc.querySelector('[data-drawer-vehicles-btn]');
    var accPanel = acc.querySelector('[data-drawer-panel]');
    var makesBox = acc.querySelector('[data-drawer-makes]');
    var famsView = acc.querySelector('[data-drawer-fams]');
    var famsTitle = acc.querySelector('[data-drawer-fams-title]');
    var famsList = acc.querySelector('[data-drawer-fams-list]');
    var backBtn = acc.querySelector('[data-drawer-back]');
    var drawerBuilt = false;

    function showMakes() {
      famsView.hidden = true;
      makesBox.hidden = false;
    }

    function showFamilies(mk) {
      famsTitle.textContent = mk.name;
      famsList.textContent = '';
      var all = link('drawer-fam-all', 'All ' + mk.name + ' parts', mk);
      famsList.appendChild(all);
      mk.families.forEach(function (f) {
        famsList.appendChild(link('drawer-fam', f.name, f));
        if (f.generations && f.generations.length) {
          f.generations.forEach(function (g) {
            famsList.appendChild(link('drawer-gen', genLabel(g), g));
          });
        }
      });
      makesBox.hidden = true;
      famsView.hidden = false;
      accPanel.scrollTop = 0;
    }

    function buildDrawer(d) {
      makesBox.textContent = '';
      sortedByName(d.makes).forEach(function (mk) {
        var b = el('button', 'drawer-make', mk.name);
        b.type = 'button';
        b.addEventListener('click', function () { showFamilies(mk); });
        makesBox.appendChild(b);
      });
      if (d.universal && d.universal.handle) {
        makesBox.appendChild(link('drawer-universal', d.universal.title || 'Universal parts', d.universal));
      }
      drawerBuilt = true;
    }

    accBtn.addEventListener('click', function () {
      var openNow = accPanel.hidden;
      accPanel.hidden = !openNow;
      acc.classList.toggle('is-open', openNow);
      accBtn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      if (openNow && !drawerBuilt) {
        loadNav().then(buildDrawer).catch(function () {
          // no data: give the row a real destination instead of an empty list
          var a = el('a', 'drawer-make', 'Browse all parts');
          a.href = BASE;
          makesBox.appendChild(a);
          drawerBuilt = true;
        });
      }
    });

    backBtn.addEventListener('click', showMakes);

    // leaving the drawer resets it to the makes list
    var drawerEl = document.querySelector('[data-nav-drawer]');
    var closeEls = [document.querySelector('[data-nav-close]'), document.querySelector('[data-nav-scrim]')];
    closeEls.forEach(function (n) { if (n) n.addEventListener('click', showMakes); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerEl && !drawerEl.hidden) showMakes();
    });
  }

  /* ---- picker band (home, list-collections) ---- */
  var band = document.querySelector('[data-vehicle-picker]');
  if (band) {
    var makeSel = band.querySelector('[data-vp-make]');
    var modelSel = band.querySelector('[data-vp-model]');
    var genField = band.querySelector('[data-vp-gen-field]');
    var genSel = band.querySelector('[data-vp-generation]');
    var goBtn = band.querySelector('[data-vp-go]');
    var uniRow = band.querySelector('[data-vp-universal]');
    var uniRowLink = band.querySelector('[data-vp-universal-link]');
    var pickerData = null;

    function option(value, label) {
      var o = document.createElement('option');
      o.value = value;
      o.textContent = label;
      return o;
    }
    function resetSelect(sel, label) {
      sel.textContent = '';
      sel.appendChild(option('', label));
    }
    function currentMake() { return pickerData && pickerData.makes[makeSel.value]; }
    function currentFamily() {
      var mk = currentMake();
      return mk && mk.families[modelSel.value];
    }
    function hideGenerations() {
      genField.hidden = true;
      resetSelect(genSel, 'All years');
    }
    function resetPicker() {
      makeSel.value = '';
      resetSelect(modelSel, 'Select model');
      modelSel.disabled = true;
      hideGenerations();
      goBtn.disabled = true;
    }
    function readPickerGarage() {
      try {
        var g = JSON.parse(localStorage.getItem('bpf.garage'));
        return (g && g.v === 1 && g.makeName && g.familyName) ? g : null;
      } catch (e) { return null; }
    }
    function restorePickerGarage() {
      if (!pickerData) return;
      var g = readPickerGarage();
      if (!g) { resetPicker(); return; }
      var mk = null;
      var mkIndex = -1;
      pickerData.makes.forEach(function (m, i) {
        if (m.name === g.makeName) { mk = m; mkIndex = i; }
      });
      if (!mk) { resetPicker(); return; }
      makeSel.value = String(mkIndex);
      makeSel.dispatchEvent(new Event('change', { bubbles: true }));
      var fam = null;
      var famIndex = -1;
      mk.families.forEach(function (f, i) {
        if (f.name === g.familyName) { fam = f; famIndex = i; }
      });
      if (!fam) { resetPicker(); return; }
      modelSel.value = String(famIndex);
      modelSel.dispatchEvent(new Event('change', { bubbles: true }));
      if (genField.hidden || !g.generation) return;
      (fam.generations || []).forEach(function (gen, i) {
        if (g.generation === genLabel(gen) || g.tagHandle === handleize(gen.tag)) genSel.value = String(i);
      });
    }

    loadNav().then(function (d) {
      pickerData = d;
      alphabetical(d.makes).forEach(function (m) { makeSel.appendChild(option(String(m.i), m.name)); });
      makeSel.disabled = false;
      restorePickerGarage();
      if (d.universal && d.universal.handle) {
        uniRowLink.href = url(d.universal);
        uniRow.hidden = false;
      }
    }).catch(function () {
      band.hidden = true;
    });

    makeSel.addEventListener('change', function () {
      var mk = currentMake();
      resetSelect(modelSel, 'Select model');
      hideGenerations();
      goBtn.disabled = true;
      modelSel.disabled = !mk;
      if (!mk) return;
      alphabetical(mk.families).forEach(function (f) { modelSel.appendChild(option(String(f.i), f.name)); });
    });

    modelSel.addEventListener('change', function () {
      var fam = currentFamily();
      hideGenerations();
      goBtn.disabled = !fam;
      if (!fam || !fam.generations || !fam.generations.length) return;
      fam.generations.forEach(function (g, i) { genSel.appendChild(option(String(i), genLabel(g))); });
      genField.hidden = false;
    });

    goBtn.addEventListener('click', function () {
      var fam = currentFamily();
      if (!fam) return;
      var mk = currentMake();
      var target = fam;
      var genDisplay = '';
      if (!genField.hidden && genSel.value !== '') {
        var g = fam.generations[genSel.value];
        if (g) { target = g; genDisplay = genLabel(g); }
      }
      // remember the car so the whole site can offer parts that fit it
      try {
        localStorage.setItem('bpf.garage', JSON.stringify({
          v: 1,
          makeName: mk.name,
          familyName: fam.name,
          tag: target.tag,
          tagHandle: handleize(target.tag),
          handle: target.handle,
          generation: genDisplay || undefined
        }));
      } catch (e) {}
      window.location.href = url(target);
    });
    window.addEventListener('bpf:garagechange', restorePickerGarage);
  }

  /* ---- collection filter sidebar ----
     Native tag filtering only: every facet link is the current tag set with one
     tag added or removed, handleized, sorted (the order Shopify canonicalises
     to) and joined with '+', keeping the sort param. */
  var fpanel = document.querySelector('[data-filter-panel]');
  if (fpanel) {
    /* Search reuses this whole engine over search.filters. In search mode the
       results live under /search (query q + type), not /collections, so the
       collection, vehicle and garage machinery is skipped and refinement rides
       the native value URLs (which already preserve q and type) plus the same
       fetch swap. searchPath is the pathname a refinement anchor must match. */
    var searchMode = fpanel.hasAttribute('data-search-mode');
    var searchPath = fpanel.getAttribute('data-search-url') || '/search';
    var collUrl = fpanel.getAttribute('data-collection-url') || BASE;
    var collHandle = fpanel.getAttribute('data-collection-handle') || '';
    var sortParam = fpanel.getAttribute('data-sort') || '';
    var activeHandles = (fpanel.getAttribute('data-current-tags') || '')
      .split('~')
      .filter(function (t) { return t !== ''; })
      .map(handleize);

    function facetActive(tag) { return activeHandles.indexOf(handleize(tag)) >= 0; }

    function facetUrl(tag) {
      var h = handleize(tag);
      var list = activeHandles.slice();
      var at = list.indexOf(h);
      if (at >= 0) list.splice(at, 1);
      else list.push(h);
      list.sort();
      var u = collUrl + (list.length ? '/' + list.join('+') : '');
      return sortParam ? u + '?sort_by=' + sortParam : u;
    }

    function facetLink(tag, label, count) {
      var on = facetActive(tag);
      var a = el('a', 'facet' + (on ? ' is-active' : ''));
      a.href = facetUrl(tag);
      a.setAttribute('data-toggle-tag', handleize(tag));
      a.appendChild(el('span', null, label));
      // dormant: the nav feed may start carrying per option product counts
      if (count != null && count !== '' && !on) a.appendChild(el('span', 'facet-count', String(count)));
      if (on) a.setAttribute('aria-label', 'Clear the ' + label + ' filter');
      return a;
    }

    /* Adaptive collapse count. A long facet list collapses to N rows behind one
       "Show all" toggle that expands in place; the sidebar grows and the page
       scrolls, so there is never a nested scrollbox. N is not a constant: it is
       read once per collapseList run from the viewport height and how many groups
       are open, so a short screen or several open groups compress harder and a
       tall screen with one group open shows more. Rows are about 34px tall; the
       open groups share roughly 55 percent of the viewport (the rest is
       headings, the typeahead, the toolbar and breathing room), split evenly,
       clamped to a sane 5..12. One-shot read at render time, not a resize engine:
       it recomputes only when a group is (re)built or a toggle fires. Open group
       = a [data-filter-group] that is not hidden, is laid out (so the desktop
       availability group, which is display:none, does not count) and whose
       [data-group-body] is not collapsed shut. */
    function openGroupCount() {
      var n = 0;
      [].slice.call(fpanel.querySelectorAll('[data-filter-group]')).forEach(function (g) {
        if (g.hidden || g.offsetParent === null) return;
        var body = g.querySelector('[data-group-body]');
        if (body && !body.hidden) n++;
      });
      return n;
    }
    function facetLimit() {
      var open = Math.max(1, openGroupCount());
      var n = Math.floor((window.innerHeight * 0.55) / 34 / open);
      return Math.max(5, Math.min(12, n));
    }

    /* One scroll surface on desktop, and only one: the page. The sidebar is
       sticky (top: 20px) with no overflow of its own, so when its content grows
       taller than the viewport it would pin with its lower groups below the fold
       and unreachable. Measure once after a group is (re)built or a toggle fires:
       taller than the space between the 20px top and 20px bottom breathing room
       drops it to static (.is-flowing) so it flows with the page and the page
       scroll reaches the bottom; when it fits again sticky is restored. Desktop
       only; the mobile drawer is a modal with its own overflow. One-shot at
       mutation points, no resize listener and no observer. */
    function reflowSidebar() {
      if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;
      fpanel.classList.remove('is-flowing');
      if (fpanel.scrollHeight > window.innerHeight - 40) fpanel.classList.add('is-flowing');
    }

    function showGroup(name) {
      var g = fpanel.querySelector('[data-filter-' + name + ']');
      if (g) g.hidden = false;
      return g;
    }

    /* Accordion. Rendered expanded by Liquid so the sidebar works without JS;
       here the headers become real controls and the page-appropriate group is
       the one left open. Any group holding an active filter opens. */
    function setGroupOpen(group, open) {
      var body = group.querySelector('[data-group-body]');
      var btn = group.querySelector('[data-group-toggle]');
      if (!body || !btn) return;
      body.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      group.classList.toggle('is-open', open);
    }

    function wireGroup(group) {
      var btn = group.querySelector('[data-group-toggle]');
      if (!btn || btn.dataset.wired) return;
      btn.dataset.wired = '1';
      var hasActive = !!group.querySelector('.facet.is-active');
      setGroupOpen(group, hasActive || group.getAttribute('data-group-open') === 'true');
      btn.addEventListener('click', function () {
        setGroupOpen(group, group.querySelector('[data-group-body]').hidden);
      });
    }

    /* Long lists collapse by count, never by scrollbox: the extras past the cut
       are hidden and one toggle expands them in place, the sidebar grows and the
       page scrolls. This is the collapse-only rule the 42vh scrollbox briefly
       superseded; the scrollbox is gone and collapse-only is back in force. One
       unified button owns two kinds of trimmed row: the count overflow (rows past
       N) and the fit-matrix rows the vehicle context hides (data-nofit). Collapsed
       shows the first N rows that are not data-nofit, plus any active row wherever
       it sits; expanded shows everything, including the data-nofit rows. The
       button reads "Show all <total>" collapsed and "Show fewer" expanded, total
       counting every option row. apply() owns the button's visibility outright,
       so a typeahead clear can never flash a stale empty button. The expanded
       flag is remembered on the group (data-facet-expanded) so it survives a
       fetch-swap that re-renders the body. Rows are .facet, .facet-toggle and
       .filter-check (the native brand checkboxes ride the same engine). */
    function collapseList(group) {
      var list = group.querySelector('[data-facet-list]');
      var more = group.querySelector('[data-facet-more]');
      if (!list || !more) return;
      var items = [].slice.call(list.children).filter(function (n) {
        return n.classList && (n.classList.contains('facet') || n.classList.contains('facet-toggle') || n.classList.contains('filter-check'));
      });
      var total = items.length;
      var N = facetLimit();
      // collapsing a list to hide one or two rows is worse than showing it whole
      var collapses = total > N + 2;
      var expanded = collapses && group.getAttribute('data-facet-expanded') === '1';

      // an active row stays visible even past the cut: a highlighted facet, or a
      // checked native checkbox (server applied, or ticked but not yet applied),
      // or a make whose family sub-list holds an active facet
      function isActiveRow(n) {
        if (n.classList.contains('is-active')) return true;
        var cb = n.querySelector ? n.querySelector('input[type="checkbox"]') : null;
        if (cb && cb.checked) return true;
        var sub = n.nextElementSibling;
        if (sub && sub.classList && sub.classList.contains('facet-sub') && sub.querySelector('.facet.is-active')) return true;
        return false;
      }

      function apply() {
        if (!collapses) {
          items.forEach(function (n) {
            n.hidden = false;
            var sub = n.nextElementSibling;
            if (sub && sub.classList && sub.classList.contains('facet-sub') && sub.dataset.open === '1') sub.hidden = false;
          });
          more.hidden = true;
          return;
        }
        var count = 0; // rows shown by the plain count rule (not data-nofit, not active)
        items.forEach(function (n) {
          var nofit = n.getAttribute && n.getAttribute('data-nofit') === '1';
          var show;
          if (expanded) show = true;
          else if (isActiveRow(n)) show = true;
          else if (nofit) show = false;
          else if (count < N) { show = true; count++; }
          else show = false;
          n.hidden = !show;
          var sub = n.nextElementSibling;
          if (sub && sub.classList && sub.classList.contains('facet-sub')) {
            // a collapsed make hides its family list with it
            if (!show) sub.hidden = true;
            else if (sub.dataset.open === '1') sub.hidden = false;
            else if (expanded) sub.hidden = false;
          }
        });
        more.hidden = false;
        more.textContent = expanded ? 'Show fewer' : 'Show all ' + total;
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      apply();
      // the type-ahead restores this collapsed view when its box is cleared; it
      // also syncs the persisted flag, so a later fetch-swap does not resurrect a
      // stale expansion
      group.__collapseSet = function (exp) {
        expanded = collapses && exp;
        if (expanded) group.setAttribute('data-facet-expanded', '1');
        else group.removeAttribute('data-facet-expanded');
        apply();
        reflowSidebar();
      };
      more.onclick = function () { group.__collapseSet(!expanded); };
    }

    /* Type-ahead: any option list longer than twelve rows gets a small filter
       box so a shopper narrows by typing instead of scanning. While the query is
       non-empty it shows every text match regardless of the collapse state or the
       fit-matrix trim and hides the more button; clearing the box restores the
       collapsed view through __collapseSet, which also resets the persisted
       expanded flag. It never sets the more button visible itself: apply() owns
       that, so a cleared box can never flash a stale empty button. */
    function addTypeAhead(group) {
      var list = group.querySelector('[data-facet-list]');
      var body = group.querySelector('[data-group-body]');
      if (!list || !body || group.querySelector('.facet-typeahead')) return;
      var rows = [].slice.call(list.children).filter(function (n) {
        return n.classList && (n.classList.contains('facet') || n.classList.contains('facet-toggle') || n.classList.contains('filter-check'));
      });
      if (rows.length <= 12) return;
      var more = group.querySelector('[data-facet-more]');
      var input = el('input', 'facet-typeahead');
      input.type = 'search';
      input.placeholder = group.hasAttribute('data-filter-vehicle') ? 'Find your model' : 'Filter options';
      input.setAttribute('aria-label', 'Filter options');
      // these boxes can live inside the native filters GET form (brand): Enter
      // must filter the list in place, never submit and navigate the form
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      body.insertBefore(input, body.firstChild);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        if (!q) {
          if (group.__collapseSet) group.__collapseSet(false);
          else rows.forEach(function (n) { n.hidden = false; });
          reflowSidebar();
          return;
        }
        if (more) more.hidden = true;
        rows.forEach(function (n) {
          var show = (n.textContent || '').toLowerCase().indexOf(q) >= 0;
          n.hidden = !show;
          var sub = n.nextElementSibling;
          if (sub && sub.classList && sub.classList.contains('facet-sub')) sub.hidden = true;
        });
        reflowSidebar();
      });
    }

    function finishGroup(group) {
      if (!group) return;
      collapseList(group);
      addTypeAhead(group);
      wireGroup(group);
      reflowSidebar();
    }

    /* mobile drawer */
    var fOpen = document.querySelector('[data-filter-open]');
    var fClose = fpanel.querySelector('[data-filter-close]');
    var fScrim = document.querySelector('[data-filter-scrim]');
    function openFilters() {
      if (fScrim) fScrim.hidden = false;
      requestAnimationFrame(function () {
        fpanel.classList.add('is-open');
        if (fScrim) fScrim.classList.add('is-open');
      });
      if (fOpen) fOpen.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      fpanel.classList.remove('is-open');
      if (fScrim) fScrim.classList.remove('is-open');
      if (fOpen) fOpen.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { if (fScrim) fScrim.hidden = true; }, 220);
    }
    if (fOpen) fOpen.addEventListener('click', openFilters);
    if (fClose) fClose.addEventListener('click', closeFilters);
    if (fScrim) fScrim.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fpanel.classList.contains('is-open')) closeFilters();
    });

    /* ---- instant refinement engine ----
       Zero section theme, so refinement is fetch + DOMParser, never the section
       rendering API. A tap inside the panel or on pagination fetches the target,
       swaps the results, count and chips nodes, pushStates the clean URL and
       updates the title, all without a full load. Back and forward re-fetch, and
       any failure falls back to a real navigation, so with no JS every link is
       still a working href. Hide out of stock is the native Search and Discovery
       availability filter: toggling it rebuilds the URL with the native param and
       rides this same fetch swap, so the server filters and re-paginates and a
       page is never left blank. It only exists on collections of 5,000 products
       or fewer (the platform limit); larger collections get no control. */
    var ORIGIN = window.location.origin;
    var resultsEl = document.querySelector('[data-swap="results"]');
    var countEl = document.querySelector('[data-swap="count"]');
    var chipsEl = fpanel.querySelector('[data-swap="chips"]');
    var breadcrumbEl = document.querySelector('[data-swap="breadcrumb"]');
    var collMain = document.querySelector('.coll-main');
    var countRaw = countEl ? countEl.textContent : '';

    // the two Hide out of stock slots: the toolbar toggle (desktop) and the
    // drawer availability group (mobile). Each holds a server rendered control
    // when native availability is configured, and nothing otherwise.
    var availGroup = fpanel.querySelector('[data-filter-availability]');
    var toolbarInstock = document.querySelector('[data-toolbar-instock]');
    var knownVehicleHandles = {}; // filled once nav loads, for category switches
    var vehicleCollectionToTag = {}; // dedicated vehicle collection handle -> its vehicle tag handle
    var vehicleTagToCollection = {}; // vehicle tag handle -> its dedicated vehicle collection handle
    var vehicleLabelByHandle = {}; // vehicle tag handle -> display label, for the pdp context write

    function parseColl(href) {
      var u = new URL(href, ORIGIN);
      var segs = u.pathname.replace(/^\/+/, '').replace(/\/+$/, '').split('/');
      var isColl = segs[0] === 'collections';
      return {
        handle: (isColl && segs[1]) ? segs[1] : 'all',
        tags: (isColl && segs[2]) ? decodeURIComponent(segs[2]).split('+').filter(Boolean) : [],
        origin: u.origin,
        pathname: u.pathname
      };
    }
    /* In stock only is the default. Every refinement carries the availability
       filter forward unless the shopper opted into sold out items (the
       bpf.showoos session flag) or an availability filter is already applied to
       the URL being built. This lands the first hop onto a native surface (for
       example /all -> a dedicated collection) in stock filtered with no flash,
       and the param then persists on its own because buildRefineUrl copies the
       live query. It is a Shopify system param, inert on collections without
       native filters, so carrying it everywhere is harmless. */
    var AVAIL_PARAM = 'filter.v.availability';
    function showOos() {
      try { return sessionStorage.getItem('bpf.showoos') === '1'; } catch (e) { return false; }
    }
    function setShowOos(on) {
      try { if (on) sessionStorage.setItem('bpf.showoos', '1'); else sessionStorage.removeItem('bpf.showoos'); } catch (e) {}
    }
    function paramsHaveAvailability(params) {
      var found = false;
      params.forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 && k.indexOf('availability') >= 0) found = true;
      });
      return found;
    }
    function applyAvailabilityDefault(params) {
      if (showOos()) return;
      if (!paramsHaveAvailability(params)) params.set(AVAIL_PARAM, '1');
    }
    function buildRefineUrl(handle, tags, overrides) {
      tags = (tags || []).slice().filter(Boolean).sort();
      var params = new URLSearchParams(window.location.search);
      params.delete('page'); // a refinement returns to page one
      overrides = overrides || {};
      Object.keys(overrides).forEach(function (k) {
        if (overrides[k] == null) params.delete(k); else params.set(k, overrides[k]);
      });
      applyAvailabilityDefault(params); // in stock only, unless opted out or already set
      var path = '/collections/' + handle + (tags.length ? '/' + tags.join('+') : '');
      var qs = params.toString();
      return path + (qs ? '?' + qs : '');
    }
    // same-origin collection href normalised to a path + query the engine can fetch
    function normalizeHref(href) {
      var u = new URL(href, ORIGIN);
      var qs = u.searchParams.toString();
      return u.pathname + (qs ? '?' + qs : '') + (u.hash || '');
    }

    window.__bpfRefineCount = 0;
    function setVeil(on) { if (resultsEl) resultsEl.classList.toggle('is-refining', on); }
    function clearPending() {
      [].slice.call(document.querySelectorAll('.is-pending')).forEach(function (n) { n.classList.remove('is-pending'); });
    }
    function markPending(t) {
      var n = t.closest ? (t.closest('.facet, .chip, .page-btn, .filter-check') || t) : t;
      n.classList.add('is-pending');
    }
    function facetXSvg() {
      return '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    }
    function syncFacetStates(cur) {
      var set = {}; cur.tags.forEach(function (h) { set[h] = 1; });
      [].slice.call(fpanel.querySelectorAll('[data-toggle-tag]')).forEach(function (n) {
        var on = !!set[n.getAttribute('data-toggle-tag')];
        n.classList.toggle('is-active', on);
        // keep the inline clear (x) in step with the active state, so a
        // subcategory toggled through the instant swap matches a full page load
        var x = n.querySelector('.facet-x');
        if (on && !x) {
          var span = n.querySelector('span');
          var xn = el('span', 'facet-x');
          xn.innerHTML = facetXSvg();
          n.appendChild(xn);
          if (span) n.setAttribute('aria-label', 'Clear the ' + span.textContent + ' filter');
        } else if (!on && x) {
          x.parentNode.removeChild(x);
          n.removeAttribute('aria-label');
        }
      });
      [].slice.call(fpanel.querySelectorAll('[data-cat]')).forEach(function (n) {
        n.classList.toggle('is-active', n.getAttribute('data-cat') === cur.handle);
      });
    }
    function updateDrawerShow() {
      var btn = fpanel.querySelector('[data-drawer-show]');
      if (!btn) return;
      var m = (countRaw || '').match(/[\d,]+/);
      var n = m ? m[0] : '';
      btn.textContent = 'Show ' + n + ' result' + (n === '1' ? '' : 's');
    }
    /* Keep the two Hide out of stock slots honest after a swap. The toolbar
       wrapper and the drawer availability group live outside the swapped
       results, so their control is copied from the fetched document: its server
       rendered checked state and native param are the source of truth. When the
       document carries no control (a swap onto an over-5,000 product collection),
       the slot is emptied and hidden; when it carries one, the slot is revealed.
       The delegated change listener survives these DOM replacements. */
    function syncAvailSlots(doc) {
      if (toolbarInstock) {
        var docTb = doc.querySelector('[data-toolbar-instock]');
        var tbControl = docTb ? docTb.querySelector('[data-instock-toggle]') : null;
        toolbarInstock.innerHTML = docTb ? docTb.innerHTML : '';
        toolbarInstock.hidden = !tbControl;
      }
      if (availGroup) {
        var docAg = doc.querySelector('[data-filter-availability]');
        var agControl = docAg ? docAg.querySelector('[data-instock-toggle]') : null;
        var liveBody = availGroup.querySelector('[data-group-body]');
        var docBody = docAg ? docAg.querySelector('[data-group-body]') : null;
        if (liveBody) liveBody.innerHTML = docBody ? docBody.innerHTML : '';
        availGroup.hidden = !agControl;
        if (agControl) finishGroup(availGroup);
      }
    }
    function afterSwap(url, opts, doc) {
      if (searchMode) {
        /* Search has no collection or vehicle context to move onto the swapped
           view, and no universal bridge. Re-sync the native Category group from
           the fetched document, keep the drawer count honest, update history and
           the page-scroll on pagination, and bump the refine counter. */
        syncCategoryGroup(doc);
        updateDrawerShow();
        clearPending();
        if (opts.replace) window.history.replaceState({ bpf: 1 }, '', url);
        else if (!opts.pop) window.history.pushState({ bpf: 1 }, '', url);
        if (!opts.pop && /[?&]page=/.test(url) && (collMain || resultsEl)) {
          var stop = (collMain || resultsEl).getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo(0, Math.max(0, stop));
        }
        window.__bpfRefineCount++;
        return;
      }
      var cur = parseColl(url);
      // move the live context onto the swapped view so facet links recompute
      collHandle = cur.handle;
      collUrl = BASE + '/' + cur.handle;
      activeHandles = cur.tags.slice();
      refreshVehicleGroup();
      syncCategoryGroup(doc);
      syncFacetStates(cur);
      updateDrawerShow();
      clearPending();
      if (opts.replace) window.history.replaceState({ bpf: 1 }, '', url);
      else if (!opts.pop) window.history.pushState({ bpf: 1 }, '', url);
      // after the URL is current, so the universal link can read a live
      // availability param off it (on pop the browser already updated the URL)
      updateUniversalLink();
      if (!opts.pop && /[?&]page=/.test(url) && (collMain || resultsEl)) {
        var top = (collMain || resultsEl).getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo(0, Math.max(0, top));
      }
      window.__bpfRefineCount++;
    }
    function refine(url, opts) {
      opts = opts || {};
      setVeil(true);
      fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nr = doc.querySelector('[data-swap="results"]');
          var nc = doc.querySelector('[data-swap="count"]');
          var nch = doc.querySelector('[data-swap="chips"]');
          var nbc = doc.querySelector('[data-swap="breadcrumb"]');
          if (!nr || !nc) throw new Error('missing swap nodes');
          if (resultsEl) resultsEl.innerHTML = nr.innerHTML;
          countRaw = nc.textContent;
          if (countEl) countEl.textContent = countRaw;
          if (chipsEl && nch) chipsEl.innerHTML = nch.innerHTML;
          if (breadcrumbEl && nbc) breadcrumbEl.innerHTML = nbc.innerHTML;
          if (doc.title) document.title = doc.title;
          syncAvailSlots(doc);
          afterSwap(url, opts, doc);
          setVeil(false);
        })
        .catch(function () { window.location.href = url; });
    }

    /* The one canonical read of "which vehicle is in play right now", used by
       every sidebar composition so the car survives a category switch no matter
       how it was established. Priority: (a) a vehicle tag already in the URL
       path; (b) a dedicated vehicle collection, whose vehicle lives in the
       collection HANDLE, not the path (the url-mode flip to ~700 published
       vehicle collections made this the common case, and the old path-only read
       composed nothing here); (c) none. Garage is deliberately not consulted:
       it is a click-time link rewrite with its own guards, not sidebar state. */
    function currentVehicleTagHandles() {
      if (!navFacetData) return activeHandles.slice(); // nav not loaded yet: best effort
      var fromTags = activeHandles.filter(function (h) { return knownVehicleHandles[h]; });
      if (fromTags.length) return fromTags;
      var mapped = vehicleCollectionToTag[collHandle];
      return mapped ? [mapped] : [];
    }
    // does a target URL still carry a vehicle (path tag or dedicated collection)?
    function urlHasVehicle(u) {
      var pc = parseColl(u);
      if (pc.tags.some(function (h) { return knownVehicleHandles[h]; })) return true;
      return !!vehicleCollectionToTag[pc.handle];
    }

    /* Universal parts bridge. A tag-composed view (a category collection plus at
       least one vehicle tag) filters by an AND, so that category's universal
       parts, which carry no vehicle tag, drop out of the count. Offer the
       category's universal slice as one quiet secondary link, but only where the
       matrix says the category actually stocks universal items. This is
       category-scoped, so it stays null on a dedicated vehicle collection, which
       has no category context. Note: dedicated vehicle collections are a single
       vehicle-tag rule now (the Universal rule was removed), so they no longer
       fold universal parts in; universal is not reachable from a bare vehicle
       collection view, only once a category is chosen. The slot lives in the
       template, outside the swapped results, so this runs after every refinement
       to keep it in step. */
    function composedCategory() {
      if (!categoryNavData || !categoryNavData.categories) return null;
      if (!collHandle || collHandle === 'all') return null;
      if (vehicleCollectionToTag[collHandle]) return null;   // dedicated vehicle collection: no category context
      if (!currentVehicleTagHandles().length) return null;   // no vehicle tag: not composed
      var cat = null;
      categoryNavData.categories.forEach(function (c) { if (c.handle === collHandle) cat = c; });
      return cat; // null when this collection is not a known category
    }
    function categoryHasUniversal(cat) {
      var u = matrixData && matrixData.universal;
      if (!u || !Array.isArray(matrixData.categories)) return false;
      var set = {};
      (u.c || []).forEach(function (i) {
        var n = matrixData.categories[i];
        if (n != null) set[String(n).toLowerCase()] = 1;
      });
      return set[cat.handle.toLowerCase()] === 1 || set[cat.name.toLowerCase()] === 1;
    }
    function updateUniversalLink() {
      var slot = document.querySelector('[data-universal-slot]');
      if (!slot) return;
      var cat = composedCategory();
      if (!cat || !categoryHasUniversal(cat)) { slot.hidden = true; slot.textContent = ''; return; }
      // carry the sort and any live availability filter onto the universal slice
      var params = new URLSearchParams();
      if (sortParam) params.set('sort_by', sortParam);
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 && k.indexOf('availability') >= 0) params.set(k, v);
      });
      var uqs = params.toString();
      var href = BASE + '/' + collHandle + '/universal' + (uqs ? '?' + uqs : '');
      var a = slot.querySelector('a');
      if (!a) { a = el('a', 'universal-link'); slot.appendChild(a); }
      a.href = href;
      a.textContent = '+ Universal ' + cat.name + ' parts';
      slot.hidden = false;
    }
    /* Garage clearing, kept symmetric with setting. Explicitly removing the
       vehicle must also drop the saved garage: otherwise the very next category
       click silently re-applies the car through the garage link rewrite, which
       reads as the filter refusing to die. So a Clear all, or any click that
       takes a view WITH a vehicle to one WITHOUT, clears the garage; dropping a
       category while the car stays does not. Setting a car (picker, mega menu,
       sidebar facet, drawer) still writes the garage as before. */
    function maybeClearGarageForClick(t, url) {
      if (!(window.BPF && window.BPF.clearGarage)) return;
      var isClearAll = t.closest && t.closest('.filter-clear, [data-drawer-clear]');
      var removedVehicle = currentVehicleTagHandles().length > 0 && !urlHasVehicle(url);
      if (isClearAll || removedVehicle) window.BPF.clearGarage();
    }

    function refineTargetFor(t) {
      if (searchMode) {
        /* Search has no tag or category-switch facets: every refinement (a
           native value, a chip x, pagination) is a plain same-origin anchor
           whose href already carries q and type. Accept it only when it stays on
           the search path, so a product card link falls through to a real
           navigation. */
        var sa = t.closest ? t.closest('a[href]') : null;
        if (!sa) return null;
        var shref = sa.getAttribute('href');
        if (!shref || shref.charAt(0) === '#') return null;
        var su;
        try { su = new URL(shref, ORIGIN); } catch (e) { return null; }
        if (su.origin !== ORIGIN || su.pathname !== searchPath) return null;
        return normalizeHref(shref);
      }
      var cur = parseColl(window.location.href);
      if (t.hasAttribute('data-toggle-tag')) {
        var tag = t.getAttribute('data-toggle-tag');
        var tags = cur.tags.slice();
        var at = tags.indexOf(tag);
        var adding = at < 0;
        if (at >= 0) tags.splice(at, 1); else tags.push(tag);
        /* Prefer a dedicated vehicle collection. Adding a vehicle tag while on
           /collections/all, or while on a dedicated vehicle collection (a
           switch to a more specific sibling or generation), targets that
           vehicle's own collection: the canonical per-vehicle surface, which
           settles small enough to carry the native Storefront filters. On a
           category collection we keep the composed
           /collections/<category>/<vehicle-tag> form instead, because the native
           filters survive and re-count there and the universal-parts bridge
           depends on it. A vehicle tag with no dedicated collection falls through
           to the /all/<tag> (or on-collection) composition below. */
        if (adding && knownVehicleHandles[tag] && vehicleTagToCollection[tag]) {
          var onAll = cur.handle === 'all';
          var onDedicatedVehicle = !!vehicleCollectionToTag[cur.handle];
          if (onAll || onDedicatedVehicle) {
            // the collection IS the vehicle now, so drop vehicle tags from the
            // path and keep any non-vehicle tags (a type tag, say)
            var keptTags = tags.filter(function (h) { return !knownVehicleHandles[h]; });
            return buildRefineUrl(vehicleTagToCollection[tag], keptTags);
          }
        }
        return buildRefineUrl(cur.handle, tags);
      }
      if (t.hasAttribute('data-cat')) {
        var ch = t.getAttribute('data-cat');
        var keep = currentVehicleTagHandles();
        return buildRefineUrl(ch === cur.handle ? 'all' : ch, keep);
      }
      var a = t.closest ? t.closest('a[href]') : null;
      if (!a) return null;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return null;
      var p = parseColl(href);
      if (p.origin !== ORIGIN || !/^\/collections\//.test(p.pathname)) return null;
      // a within: product link (/collections/<handle>/products/<handle>) is a
      // plain navigation to a product page, never a refinement and never a
      // vehicle removal. The within: change made card hrefs start with
      // /collections/, so without this guard the click delegation hijacked the
      // card into the refine engine, where maybeClearGarageForClick read the
      // vehicle-less product path as "the car was removed" and wiped the garage
      // (the header chip then vanished). Return null so the click stays an
      // ordinary navigation and the garage survives.
      if (p.pathname.indexOf('/products/') >= 0) return null;
      return normalizeHref(href);
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target.closest ? e.target.closest('a[href], [data-toggle-tag], [data-cat]') : null;
      if (!t) return;
      if (!(t.closest('[data-filter-panel]') || (resultsEl && resultsEl.contains(t)))) return;
      var url = refineTargetFor(t);
      if (!url) return;
      e.preventDefault();
      if (!searchMode) maybeClearGarageForClick(t, url); // search is store-wide: no garage coupling
      markPending(t);
      refine(url, {});
    });

    /* Carry the referring vehicle context to the product page. A collection grid
       card links product.url within: its collection, so it lands on
       /collections/<coll>/products/<handle>. That within: pathname is IDENTICAL
       whether the shopper was on a plain category view or on a composed
       category+vehicle view, so the product page cannot tell from its URL which
       car (if any) was in play. At click time we still know it, so stash it in
       sessionStorage for the product breadcrumb to read: no URL param, so
       canonicals and copied URLs stay clean, and it survives back/forward within
       the tab. Capture phase and never preventDefault: this is a pure side
       effect that must run before the navigation starts. Modified clicks (new
       tab and so on) may write too, which is harmless. We ALWAYS overwrite on
       every product click from a collection, INCLUDING when there is no vehicle
       (veh null), so a stale vehicle from an earlier composed visit to this same
       product cannot leak onto a later plain-category visit (the within: pathname
       is identical in both cases, so a matching-path read would otherwise reuse
       the old car). */
    document.addEventListener('click', function (e) {
      if (!resultsEl) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !resultsEl.contains(a)) return;
      var href = a.getAttribute('href');
      if (!href) return;
      var u;
      try { u = new URL(href, ORIGIN); } catch (err) { return; }
      if (u.origin !== ORIGIN || u.pathname.indexOf('/products/') < 0) return;
      var veh = currentVehicleTagHandles()[0] || null;
      var ctx = {
        p: u.pathname,
        veh: veh,
        vehLabel: veh ? (vehicleLabelByHandle[veh] || null) : null,
        collIsVehicle: !!vehicleCollectionToTag[collHandle]
      };
      try { sessionStorage.setItem('bpf.pdpctx', JSON.stringify(ctx)); } catch (err) {}
    }, true);

    var drawerShow = fpanel.querySelector('[data-drawer-show]');
    if (drawerShow) drawerShow.addEventListener('click', function () { closeFilters(); });
    window.addEventListener('popstate', function () { refine(window.location.href, { pop: true }); });

    /* Hide out of stock. The control only exists when the server rendered a
       native availability toggle (collections of 5,000 products or fewer), so a
       toggle present at load means reveal both slots exactly as before: the
       drawer group (shown in the drawer, hidden on desktop by CSS) and the
       toolbar wrapper (shown on desktop, hidden on mobile by CSS). */
    if (document.querySelector('[data-instock-toggle]')) {
      if (availGroup) { availGroup.hidden = false; finishGroup(availGroup); }
      if (toolbarInstock) toolbarInstock.hidden = false;
    }

    /* One document level listener drives every Show out of stock toggle, in
       either slot, and survives the DOM being replaced by a swap. Inverted
       default: in stock only is the default, so a CHECKED box means show sold
       out items (drop the availability param and remember the choice in the
       bpf.showoos session flag); UNCHECKED means hide them (apply the in stock
       param and clear the flag). It reads the native param off the control's
       [data-instock-native] label, rebuilds the URL from the current location
       (always returning to page one) and runs it through the same fetch swap the
       tag facets use. The server does the filtering and the pagination, so a
       blank page is structurally impossible. */
    document.addEventListener('change', function (e) {
      var toggle = e.target.closest ? e.target.closest('[data-instock-toggle]') : null;
      if (!toggle) return;
      var native = toggle.closest('[data-instock-native]');
      if (!native) return;
      var param = native.getAttribute('data-param');
      if (!param) return;
      var value = native.getAttribute('data-value') || '1';
      var u = new URL(window.location.href);
      u.searchParams.delete(param);
      if (toggle.checked) {
        setShowOos(true);           // show out of stock: default off for this session
      } else {
        u.searchParams.set(param, value); // hide out of stock: in stock only
        setShowOos(false);
      }
      u.searchParams.delete('page');
      var qs = u.searchParams.toString();
      refine(u.pathname + (qs ? '?' + qs : ''), {});
    });

    /* Opting into sold out items from the empty state (the Show out of stock
       link there) sets the same session flag, so the default is not re-applied
       on the next click or load. The link itself sits in the results region and
       rides the normal refine flow to its url_to_remove. */
    document.addEventListener('click', function (e) {
      var opt = e.target.closest ? e.target.closest('[data-avail-optout]') : null;
      if (opt) setShowOos(true);
    });

    /* Legacy instock URLs, one shot. An old shared or bookmarked link may still
       carry the client engine's instock param. instock=1 asked for in stock
       only: if a native toggle exists, reload once with the native param applied
       so the server filters it. instock=0 asked to show everything: record the
       show out of stock choice before stripping, so the new in stock default is
       not re-applied. Either way the legacy param is gone afterward, so this
       never loops. */
    (function migrateLegacyInstock() {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('instock')) return;
      var wasOn = u.searchParams.get('instock') === '1';
      var wasShowAll = u.searchParams.get('instock') === '0';
      var native = document.querySelector('[data-instock-native]');
      u.searchParams.delete('instock');
      if (wasShowAll) setShowOos(true);
      if (native && wasOn) {
        u.searchParams.set(native.getAttribute('data-param'), native.getAttribute('data-value') || '1');
        var qs1 = u.searchParams.toString();
        window.location.replace(u.pathname + (qs1 ? '?' + qs1 : ''));
      } else {
        var qs2 = u.searchParams.toString();
        window.history.replaceState(null, '', u.pathname + (qs2 ? '?' + qs2 : ''));
      }
    })();

    /* First paint default enforcement. Runs once on load (not after swaps),
       called from the nav-loaded callbacks above so the inbound vehicle hop gets
       first refusal. When a native availability control exists, the URL carries
       no availability param, and the shopper has not opted into sold out items,
       refine to the in stock only URL with replace semantics, so Back does not
       trap on the unfiltered state. On over-5,000 surfaces no control renders and
       this is a no-op, so everything shows with the honest Sold out badges. */
    function enforceInstockDefault() {
      var native = document.querySelector('[data-instock-native]');
      if (!native) return;
      var u = new URL(window.location.href);
      if (paramsHaveAvailability(u.searchParams) || showOos()) return;
      u.searchParams.set(native.getAttribute('data-param') || AVAIL_PARAM, native.getAttribute('data-value') || '1');
      u.searchParams.delete('page');
      var qs = u.searchParams.toString();
      refine(u.pathname + (qs ? '?' + qs : ''), { replace: true });
    }

    /* No-flash injection for internal navigation. In capture phase, before the
       refine engine and garage handlers read the href, a plain primary click on
       a same-origin /collections link that carries no availability param has the
       in stock default appended straight onto the anchor's href, unless the
       shopper opted into sold out items. The click then proceeds normally, so the
       server renders the filtered page directly with no swap flash, while the DOM
       and crawlers keep clean hrefs until a click happens. Skipped for the opt
       out link, the toggle label itself, and non-collections paths. Inert on
       over-5,000 targets, verified harmless. In search mode the same treatment
       covers /search links (Clear all, the empty-state Clear filters), so
       clearing filters keeps the in stock default exactly as on collections. */
    document.addEventListener('click', function (e) {
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (showOos()) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.hasAttribute('data-avail-optout') || a.closest('[data-instock-native]')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var u;
      try { u = new URL(href, window.location.origin); } catch (err) { return; }
      if (u.origin !== window.location.origin) return;
      var searchTarget = searchMode && u.pathname === searchPath;
      if (!/^\/collections\//.test(u.pathname) && !searchTarget) return;
      // a within: product link (/collections/<handle>/products/<handle>) is a
      // product page, not a filterable collection: leave its href untouched so it
      // reaches the product with the collection context intact and no stray param
      if (u.pathname.indexOf('/products/') >= 0) return;
      if (paramsHaveAvailability(u.searchParams)) return;
      u.searchParams.set(AVAIL_PARAM, '1');
      var qs = u.searchParams.toString();
      a.setAttribute('href', u.pathname + (qs ? '?' + qs : '') + (u.hash || ''));
    }, true);

    updateDrawerShow();

    /* vehicle, generation and fitment facets come from vehicle-nav.json. The
       vehicle group is rebuilt after a swap changes the car, so an active car
       keeps showing its siblings rather than the whole make tree. */
    var navFacetData = null;
    var matrixData = null;       // vehicle-category-matrix.json, cached once loaded
    var categoryNavData = null;  // category-nav.json, cached once loaded
    var lastVehicleKey = null;
    var lastCategoryHandle = null;
    function refreshCategoryGroup() { if (collHandle !== lastCategoryHandle) buildCategories(navFacetData); }

    /* Re-sync the Category group after a fetch swap, choosing the source from
       the fetched document, not an assumption. If the fetched group is native
       (server rendered facet rows, marked data-category-native) its body
       replaces the live body and finishGroup re-runs: the header toggle sits
       outside the body and stays wired, and the typeahead, which lives inside
       the body, comes along in the fetched HTML's absence and is re-added by
       addTypeAhead (guarded, so never doubled). If the fetched group is NOT
       native (an over-5,000 surface, or a collection with no Category filter),
       fall back to the custom facet build for the new handle. lastCategoryHandle
       is forced to rebuild across a source flip so a cached handle never
       suppresses a needed switch. */
    function syncCategoryGroup(doc) {
      var group = fpanel.querySelector('[data-filter-category]');
      if (!group) return;
      var docGroup = doc ? doc.querySelector('[data-filter-category]') : null;
      var fetchedNative = !!(docGroup && docGroup.getAttribute('data-category-native') === '1');
      if (fetchedNative) {
        var liveBody = group.querySelector('[data-group-body]');
        var docBody = docGroup.querySelector('[data-group-body]');
        if (liveBody && docBody) liveBody.innerHTML = docBody.innerHTML;
        group.setAttribute('data-category-native', '1');
        group.hidden = false;
        lastCategoryHandle = collHandle;
        syncCategoryExpansion(group);
        finishGroup(group);
        updateUniversalLink(); // categoryNavData is already cached from first paint
        return;
      }
      // search only ever renders a native Category group, so there is no custom
      // facet build to fall back to
      if (searchMode) return;
      // fetched source is the custom facet: drop any native marker and force a
      // rebuild for the new handle (the flip must not be swallowed by the cache)
      group.removeAttribute('data-category-native');
      lastCategoryHandle = null;
      buildCategories(navFacetData);
    }

    /* A new collection context starts the Category facet collapsed; refining
       within the same collection (a native category value, or a vehicle tag on a
       category collection) keeps the shopper's expanded view. The context is the
       collection handle the group last rendered, remembered on the group so a
       swap can compare against it: a category link that navigates to a different
       collection resets, a same-collection refinement does not. */
    function syncCategoryExpansion(group) {
      if (!group) return;
      // search stays on one context, so a same-page refinement keeps the
      // shopper's expanded Category view; collections key on the handle
      var ctx = searchMode ? 'search' : collHandle;
      if (group.getAttribute('data-facet-context') !== ctx) group.removeAttribute('data-facet-expanded');
      group.setAttribute('data-facet-context', ctx);
    }

    function vehicleKey() {
      return collHandle + '|' + activeHandles.filter(function (h) { return knownVehicleHandles[h]; }).sort().join('+');
    }
    function resetVehicleBodies() {
      var vg = fpanel.querySelector('[data-filter-vehicle]');
      vg.querySelector('[data-group-body]').innerHTML =
        '<div class="filter-list" data-facet-list data-filter-vehicle-list></div><button type="button" class="facet-more" data-facet-more hidden></button>';
      var gg = fpanel.querySelector('[data-filter-generations]');
      gg.querySelector('[data-group-body]').innerHTML =
        '<div class="filter-list" data-facet-list data-filter-generations-list></div><button type="button" class="facet-more" data-facet-more hidden></button>';
      gg.hidden = true;
    }
    function buildVehicleGroup() {
      var d = navFacetData;
      if (!d) return;
      var ownFamily = null, isVehicleCollection = false;
      d.makes.forEach(function (mk) {
        if (mk.handle === collHandle) isVehicleCollection = true;
        mk.families.forEach(function (f) { if (f.handle === collHandle) { isVehicleCollection = true; ownFamily = f; } });
      });
      var activeMake = null;
      d.makes.forEach(function (mk) {
        if (facetActive(mk.tag)) activeMake = mk;
        mk.families.forEach(function (f) { if (facetActive(f.tag)) activeMake = mk; });
      });

      function makeRow(mk, list) {
        var btn = el('button', 'facet-toggle');
        btn.type = 'button';
        btn.appendChild(el('span', null, mk.name));
        var chev = el('span', 'facet-chev');
        chev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
        btn.appendChild(chev);
        var sub = el('div', 'facet-sub');
        sub.hidden = true;
        mk.families.forEach(function (f) { sub.appendChild(facetLink(f.tag, f.name, f.products)); });
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = sub.hidden;
          sub.hidden = !open;
          sub.dataset.open = open ? '1' : '';
          btn.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        list.appendChild(btn);
        list.appendChild(sub);
      }

      resetVehicleBodies();
      var vgroup = fpanel.querySelector('[data-filter-vehicle]');

      if (isVehicleCollection) {
        // the vehicle is already the collection: no picker, just its generations
        if (vgroup) vgroup.hidden = true;
        if (ownFamily && ownFamily.generations && ownFamily.generations.length) {
          var genList = fpanel.querySelector('[data-filter-generations-list]');
          ownFamily.generations.forEach(function (g) { genList.appendChild(facetLink(g.tag, genLabel(g))); });
          finishGroup(showGroup('generations'));
        }
      } else if (activeMake) {
        // a vehicle tag is active: the active-vehicle chip is its representation,
        // so the Vehicle group disappears entirely (owner rule). Changing car
        // happens through the chip x, the garage Change, or the mega menu.
        if (vgroup) vgroup.hidden = true;
      } else {
        // no vehicle chosen yet: the full make picker
        var list = fpanel.querySelector('[data-filter-vehicle-list]');
        sortedByName(d.makes).forEach(function (mk) { makeRow(mk, list); });
        finishGroup(showGroup('vehicle'));
      }
      lastVehicleKey = vehicleKey();
    }
    function refreshVehicleGroup() {
      if (navFacetData && vehicleKey() !== lastVehicleKey) buildVehicleGroup();
    }

    if (searchMode) {
      /* Search does not use vehicle-nav.json, the vehicle facets or the fit
         matrix: the sidebar is entirely native (Availability, Brand, Product
         type), and the blanket finishGroup below wires the visible groups. Only
         the in stock default needs enforcing on first paint. */
      enforceInstockDefault();
    } else {
    loadNav().then(function (d) {
      navFacetData = d;
      // record every vehicle tag handle, and map each dedicated vehicle
      // collection handle to its tag handle (and back), so a category switch
      // keeps the car whether the vehicle is a path tag or the collection
      // itself, and so a vehicle facet click can route to the dedicated
      // collection
      d.makes.forEach(function (mk) {
        knownVehicleHandles[handleize(mk.tag)] = 1;
        vehicleLabelByHandle[handleize(mk.tag)] = mk.name;
        if (mk.handle) { vehicleCollectionToTag[mk.handle] = handleize(mk.tag); vehicleTagToCollection[handleize(mk.tag)] = mk.handle; }
        mk.families.forEach(function (f) {
          knownVehicleHandles[handleize(f.tag)] = 1;
          vehicleLabelByHandle[handleize(f.tag)] = mk.name + ' ' + f.name;
          if (f.handle) { vehicleCollectionToTag[f.handle] = handleize(f.tag); vehicleTagToCollection[handleize(f.tag)] = f.handle; }
          (f.generations || []).forEach(function (g) {
            knownVehicleHandles[handleize(g.tag)] = 1;
            // a generation shares its family's display label, matching the garage
            vehicleLabelByHandle[handleize(g.tag)] = mk.name + ' ' + f.name;
            if (g.handle) { vehicleCollectionToTag[g.handle] = handleize(g.tag); vehicleTagToCollection[handleize(g.tag)] = g.handle; }
          });
        });
      });
      // Inbound hop: a bookmarked or crawled /collections/all/<one-vehicle-tag>
      // whose tag has a dedicated collection is sent there once, preserving the
      // query, so the shopper lands where the native filters live. Anything else
      // (many tags, an unknown tag) stays put. A hard replace, so it runs before
      // the availability default and cannot loop (the handle stops being 'all').
      if (collHandle === 'all' && activeHandles.length === 1 && vehicleTagToCollection[activeHandles[0]]) {
        window.location.replace('/collections/' + vehicleTagToCollection[activeHandles[0]] + window.location.search);
        return;
      }
      buildVehicleGroup();
      if (d.universal && d.universal.tag) {
        var uniList = fpanel.querySelector('[data-filter-universal-list]');
        uniList.appendChild(facetLink(d.universal.tag, 'Universal only'));
        finishGroup(showGroup('universal'));
      }
      buildCategories(d);
      enforceInstockDefault();
    }).catch(function () {
      // the Liquid group (active filters) still works without the JSON
      buildCategories(null);
      enforceInstockDefault();
    });
    }

    /* Category, two levels.
       Level one switches collection and carries the vehicle tags across, which
       is what makes Vehicle x Category work today. Level two composes the type
       tag into the category collection once TYPE_TAGS_LIVE is on. */
    function buildCategories(vehicleData) {
      var src = fpanel.getAttribute('data-category-src');
      if (!src) return;
      lastCategoryHandle = collHandle;
      var catGroup = fpanel.querySelector('[data-filter-category]');
      var native = catGroup && catGroup.getAttribute('data-category-native') === '1';

      // vehicle context for the fit matrix, as tag handles (the matrix keys on
      // handles); covers both a path tag and a dedicated vehicle collection
      function vehicleTagsApplied() { return currentVehicleTagHandles(); }

      // switching category keeps the active vehicle (path tag or dedicated
      // vehicle collection), never another category's type tag
      function vehicleTagHandles() { return currentVehicleTagHandles(); }

      function categoryUrl(handle, extraTagHandle) {
        var list = vehicleTagHandles();
        if (extraTagHandle && list.indexOf(extraTagHandle) < 0) list.push(extraTagHandle);
        list.sort();
        var u = BASE + '/' + handle + (list.length ? '/' + list.join('+') : '');
        return sortParam ? u + '?sort_by=' + sortParam : u;
      }

      // Native Category source wins: the server rendered the facet rows and the
      // platform trims them progressively, so the custom facet and the fit
      // matrix are skipped entirely. The category-nav fetch still runs so the
      // universal-parts bridge has its data.
      if (native) {
        fetchJson(src, 'category-nav').then(function (cd) {
          categoryNavData = cd;
          updateUniversalLink();
          var g = showGroup('category');
          syncCategoryExpansion(g);
          finishGroup(g);
        }).catch(function () { var g = showGroup('category'); syncCategoryExpansion(g); finishGroup(g); });
        return;
      }

      fetchJson(src, 'category-nav').then(function (cd) {
        categoryNavData = cd; // cache for the universal-parts bridge
        updateUniversalLink();
        // reset the group body so a rebuild after a swap does not stack
        var group = fpanel.querySelector('[data-filter-category]');
        group.querySelector('[data-group-body]').innerHTML =
          '<div class="filter-list" data-facet-list data-filter-category-list></div><button type="button" class="facet-more" data-facet-more hidden></button>';
        var list = fpanel.querySelector('[data-filter-category-list]');
        if (!list || !cd.categories) return;

        cd.categories.forEach(function (cat) {
          var here = cat.handle === collHandle;
          var a = el('a', 'facet' + (here ? ' is-active' : ''));
          a.href = here ? categoryUrl('all') : categoryUrl(cat.handle);
          a.setAttribute('data-cat', cat.handle);
          a.appendChild(el('span', null, cat.name));
          if (here) {
            a.setAttribute('aria-label', 'Clear the ' + cat.name + ' filter');
            var x = el('span', 'facet-x');
            x.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
            a.appendChild(x);
          }
          list.appendChild(a);

          // the category you are in shows its subcategories
          var subs = (cat.subcategories || []).filter(function (s) { return s.count > 0; });
          if (!here || !subs.length) return;
          var sub = el('div', 'facet-sub');
          subs.forEach(function (sc) {
            if (TYPE_TAGS_LIVE) {
              var subActive = facetActive(sc.tag);
              var sa = el('a', 'facet' + (subActive ? ' is-active' : ''));
              sa.href = categoryUrl(cat.handle, handleize(sc.tag));
              sa.setAttribute('data-type', sc.tag);
              sa.setAttribute('data-toggle-tag', handleize(sc.tag));
              sa.appendChild(el('span', null, sc.name));
              if (subActive) {
                sa.setAttribute('aria-label', 'Clear the ' + sc.name + ' filter');
                var subX = el('span', 'facet-x');
                subX.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
                sa.appendChild(subX);
              }
              sub.appendChild(sa);
            } else {
              var lb = el('span', 'facet facet-label', sc.name);
              lb.setAttribute('data-type', sc.tag);
              sub.appendChild(lb);
            }
          });
          if (!TYPE_TAGS_LIVE) {
            sub.appendChild(el('p', 'facet-note', 'Subcategory filters turn on with the next catalog update.'));
          }
          list.appendChild(sub);
        });
        syncCategoryExpansion(group);
        finishGroup(showGroup('category'));
        applyFitMatrix(cd);
      }).catch(function () {});

      /* Progressive filtering, live from assets/vehicle-category-matrix.json.
         Compact wire format pinned by the pipeline:
           { generatedAt,
             categories: [<name>...],   // dictionary, index space for c
             types:      [<name>...],   // dictionary, index space for t
             vehicles: { "<display tag>": { c: [<catIdx>...], t: [<typeIdx>...] } },
             universal:                  { c: [<catIdx>...], t: [<typeIdx>...] } }
         c and t are integer indices into the categories/types dictionaries;
         presence only, no counts (facet counts come from vehicle-nav.json's per
         family `products`). A category absent from a vehicle's set has no live
         product for that car, so it is hidden; the universal set is unioned into
         every vehicle, and one "Show all categories" escape reveals the rest.
         Categories match on name or handle, types on name, all case folded.
         Vehicle keys are display tags; the sidebar works in tag handles, so both
         are tried. Absent asset, bad shape, or an unknown vehicle: nothing is
         trimmed and everything shows. Fetched only when a vehicle is applied. */
      function applyFitMatrix(cd) {
        var matrixSrc = fpanel.getAttribute('data-matrix-src');
        var vehicleTags = vehicleTagsApplied();
        if (!matrixSrc || !vehicleTags.length) return;

        fetchJson(matrixSrc, 'vehicle-category-matrix').then(function (md) {
          matrixData = md; // cache for the universal-parts bridge
          updateUniversalLink();
          if (!md || !md.vehicles || !Array.isArray(md.categories) || !Array.isArray(md.types)) return;
          // vehicle keys are display tags; index them by handle too so the
          // sidebar's tag-handle context resolves either way
          var byHandle = {};
          Object.keys(md.vehicles).forEach(function (k) { byHandle[handleize(k)] = md.vehicles[k]; });

          var allowedCats = null;
          var allowedTypes = null;
          for (var i = 0; i < vehicleTags.length; i++) {
            var entry = md.vehicles[vehicleTags[i]] || byHandle[handleize(vehicleTags[i])];
            if (!entry) return; // unknown vehicle: leave the list alone
            allowedCats = intersect(allowedCats, idxSet(entry.c, md.categories));
            allowedTypes = intersect(allowedTypes, idxSet(entry.t, md.types));
          }
          if (md.universal) {
            allowedCats = unionInto(allowedCats, idxSet(md.universal.c, md.categories));
            allowedTypes = unionInto(allowedTypes, idxSet(md.universal.t, md.types));
          }
          if (!allowedCats) return;
          trimCategories(cd, allowedCats, allowedTypes);
        }).catch(function () {});
      }

      // resolve integer indices through a name dictionary, folded to a lookup set
      function idxSet(indices, dict) {
        var out = {};
        (indices || []).forEach(function (i) {
          var name = dict[i];
          if (name != null) out[String(name).toLowerCase()] = 1;
        });
        return out;
      }
      function intersect(a, b) {
        if (!a) return b;
        var out = {};
        Object.keys(a).forEach(function (k) { if (b[k]) out[k] = 1; });
        return out;
      }
      function unionInto(a, b) {
        var out = a || {};
        Object.keys(b).forEach(function (k) { out[k] = 1; });
        return out;
      }

      function trimCategories(cd, allowedCats, allowedTypes) {
        var group = fpanel.querySelector('[data-filter-category]');
        var list = fpanel.querySelector('[data-filter-category-list]');
        if (!group || !list) return;
        var hidden = 0;

        cd.categories.forEach(function (cat, i) {
          var row = list.querySelector('a.facet[data-cat="' + cat.handle + '"]');
          if (!row) return;
          var fits = allowedCats[cat.handle.toLowerCase()] === 1 || allowedCats[cat.name.toLowerCase()] === 1;
          var here = cat.handle === collHandle;
          if (fits || here) return;
          row.setAttribute('data-nofit', '1');
          row.hidden = true;
          hidden++;
          var sub = row.nextElementSibling;
          if (sub && sub.classList && sub.classList.contains('facet-sub')) {
            sub.setAttribute('data-nofit', '1');
            sub.hidden = true;
          }
        });

        // subcategories of the category you are in follow the same rule
        if (allowedTypes && Object.keys(allowedTypes).length) {
          [].slice.call(fpanel.querySelectorAll('[data-filter-category-list] .facet-sub > [data-type]')).forEach(function (n) {
            var t = n.getAttribute('data-type').toLowerCase();
            if (allowedTypes[t] !== 1) n.hidden = true;
          });
        }

        if (!hidden) return;
        // the fit-trimmed rows are now folded into the single Show all toggle:
        // collapseList hides data-nofit rows when collapsed and reveals them when
        // expanded, so there is no second "Show all categories" expander. Re-run
        // it so the total and the button label account for the rows just marked.
        collapseList(group);
        reflowSidebar();
      }
    }

    // Liquid-rendered groups (category) get the same treatment right away
    [].slice.call(fpanel.querySelectorAll('[data-filter-group]')).forEach(function (g) {
      if (!g.hidden) finishGroup(g);
    });

    /* ---- persistent apply for the native Storefront filters ----
       The tag facets above refine instantly, but the native Search and
       Discovery controls (availability, brand, price) only take effect through
       a GET navigation. Owner rule: the instant any native control differs from
       what the URL already applies, an Apply affordance must be visible and stay
       visible no matter the scroll position. Desktop gets a sticky bar at the
       bottom of the sidebar, shown only while dirty, with a quiet Reset that
       reverts the pending edits in place. In the drawer the existing Show
       results bar takes the job: when dirty a tap applies the pending edits
       instead of only closing, so a checked box or typed price is never dropped.
       All of it is a progressive layer: without JS the inline Apply submit still
       works as the plain GET fallback. */
    var nativeForm = fpanel.querySelector('[data-native-filters]');
    if (nativeForm) {
      var nativeChecks = [].slice.call(nativeForm.querySelectorAll('input[type="checkbox"]'));
      var nativePrices = [].slice.call(nativeForm.querySelectorAll('input[type="number"]'));
      // the native filter.* params this form actually owns. The availability
      // param is not among them: the quick Hide out of stock toggle owns it, so
      // an applied availability filter must not read as dirty here and must not
      // be dropped when the form is applied.
      var ownedNames = {};
      nativeChecks.forEach(function (c) { ownedNames[c.name] = 1; });
      nativePrices.forEach(function (p) { ownedNames[p.name] = 1; });
      var inlineApply = nativeForm.querySelector('.native-apply');
      // JS owns Apply now: the sticky bar (desktop) and the drawer bar (mobile)
      // stand in for the inline button, which stays only as the no-JS fallback.
      if (inlineApply) inlineApply.hidden = true;

      // Normalise a price field to its numeric string, so "50", "50.0" and a
      // re-typed applied value all read as unchanged.
      function priceNorm(v) {
        v = (v == null ? '' : String(v)).trim();
        if (v === '') return '';
        var n = parseFloat(v);
        return isNaN(n) ? v : String(n);
      }

      // The native state the current URL already applies, read fresh each time
      // so a Back or a pushState is always the reference.
      function appliedNative() {
        var checks = {}, prices = {};
        new URLSearchParams(window.location.search).forEach(function (v, k) {
          if (k.indexOf('filter.') !== 0 || !ownedNames[k]) return;
          if (k === 'filter.v.price.gte' || k === 'filter.v.price.lte') prices[k] = v;
          else checks[k + '\u0000' + v] = 1;
        });
        return { checks: checks, prices: prices };
      }

      function isDirty() {
        var applied = appliedNative();
        // checkboxes: the live checked set must equal the applied set exactly,
        // so toggling a box on OR back off both register as a change
        var live = {}, liveN = 0, appliedN = 0, k;
        nativeChecks.forEach(function (c) { if (c.checked) { live[c.name + '\u0000' + c.value] = 1; liveN++; } });
        for (k in applied.checks) {
          if (applied.checks.hasOwnProperty(k)) { appliedN++; if (!live[k]) return true; }
        }
        if (liveN !== appliedN) return true;
        // price: a non-empty value that differs from applied is dirty; an empty
        // field never counts (owner rule); an applied bound is cleared through
        // its chip above, not by blanking the input
        for (var i = 0; i < nativePrices.length; i++) {
          var val = priceNorm(nativePrices[i].value);
          if (val === '') continue;
          if (val !== priceNorm(applied.prices[nativePrices[i].name] || '')) return true;
        }
        return false;
      }

      /* One navigation that carries the pending native state plus the tag path
         already in the pathname, the sort, and any other live query param (an
         applied availability filter) untouched; only the form's own native
         params and pagination are rebuilt from the form, exactly as the native
         GET form would but without dropping the rest of the query. */
      function buildApplyUrl() {
        var params = new URLSearchParams(window.location.search);
        var keys = [];
        params.forEach(function (v, k) { keys.push(k); });
        // drop only the filter.* params this form owns; an applied availability
        // param (owned by the quick toggle) is left in place
        keys.forEach(function (k) { if (k.indexOf('filter.') === 0 && ownedNames[k]) params.delete(k); });
        params.delete('page'); // a fresh filter set returns to page one
        nativeChecks.forEach(function (c) { if (c.checked) params.append(c.name, c.value); });
        nativePrices.forEach(function (p) { var v = p.value.trim(); if (v !== '') params.set(p.name, v); });
        if (sortParam && !params.has('sort_by')) params.set('sort_by', sortParam);
        var qs = params.toString();
        return window.location.pathname + (qs ? '?' + qs : '');
      }
      function applyNative() { window.location.assign(buildApplyUrl()); }
      function resetNative() {
        // defaultChecked / defaultValue are the server-rendered = applied state
        nativeChecks.forEach(function (c) { c.checked = c.defaultChecked; });
        nativePrices.forEach(function (p) { p.value = p.defaultValue; });
        refreshDirty();
      }

      // Desktop apply bar, built here so it never renders without JS. CSS shows
      // it only at >=1024 and only once JS marks it dirty; below 1024 the drawer
      // bar owns the job. It is fixed to the viewport bottom, so it never falls
      // below the fold the way a strip stuck inside the tall sidebar's own scroll
      // box would; positionBar() tracks the sidebar column's left and width.
      var stickyBar = el('div', 'native-sticky');
      stickyBar.setAttribute('data-native-sticky', '');
      var resetBtn = el('button', 'native-sticky-reset', 'Reset');
      resetBtn.type = 'button';
      var applyBtn = el('button', 'btn btn-primary native-sticky-apply', 'Apply filters');
      applyBtn.type = 'button';
      stickyBar.appendChild(resetBtn);
      stickyBar.appendChild(applyBtn);
      var drawerActionsEl = fpanel.querySelector('[data-drawer-actions]');
      if (drawerActionsEl) fpanel.insertBefore(stickyBar, drawerActionsEl);
      else fpanel.appendChild(stickyBar);

      var mqDesktop = window.matchMedia('(min-width: 1024px)');
      var collLayout = document.querySelector('[data-collection-refine]') || fpanel.parentNode;
      function positionBar() {
        if (!mqDesktop.matches || !stickyBar.classList.contains('is-dirty')) return;
        var r = fpanel.getBoundingClientRect();
        stickyBar.style.left = Math.max(0, Math.round(r.left)) + 'px';
        // align the bar's right edge with the filter rows (the sidebar keeps a
        // 16px right gutter as breathing room for the counts column)
        stickyBar.style.width = Math.max(0, Math.round(r.width - 16)) + 'px';
        // drop the bar once the collection block no longer sits under it, so it
        // never floats over the footer once everything above has scrolled away
        var lr = collLayout.getBoundingClientRect();
        var barTopY = window.innerHeight - (stickyBar.getBoundingClientRect().height || 60);
        stickyBar.classList.toggle('is-offscreen', lr.bottom <= barTopY || lr.top >= window.innerHeight);
      }
      var barTick = false;
      function onScrollOrResize() {
        if (barTick) return;
        barTick = true;
        window.requestAnimationFrame(function () { barTick = false; positionBar(); });
      }
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);

      // Make every refresh of the drawer's Show-results bar dirty-aware (initial
      // paint, after a tag swap, after a stock toggle) without touching its count.
      var baseUpdateDrawerShow = updateDrawerShow;
      updateDrawerShow = function () {
        baseUpdateDrawerShow();
        if (drawerShow && isDirty()) drawerShow.textContent = 'Apply + show results';
      };

      function refreshDirty() {
        stickyBar.classList.toggle('is-dirty', isDirty());
        stickyBar.classList.remove('is-offscreen');
        positionBar();
        updateDrawerShow();
      }

      applyBtn.addEventListener('click', applyNative);
      resetBtn.addEventListener('click', resetNative);
      nativeForm.addEventListener('input', refreshDirty);
      nativeForm.addEventListener('change', refreshDirty);
      nativeForm.addEventListener('submit', function (e) { e.preventDefault(); applyNative(); });
      // the drawer bar: when dirty a tap applies the pending native edits; when
      // clean the existing listener's closeFilters() still runs
      if (drawerShow) drawerShow.addEventListener('click', function () { if (isDirty()) applyNative(); });

      refreshDirty();
    }
  }
})();

// Product info tabs
document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
  var btns = tabs.querySelectorAll('.tab-btn');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
      tabs.querySelectorAll('.tab-panel').forEach(function (pn) { pn.classList.remove('is-active'); pn.hidden = true; });
      btn.classList.add('is-active'); btn.setAttribute('aria-selected', 'true');
      var panel = tabs.querySelector('[data-panel="' + btn.dataset.tab + '"]');
      if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
    });
  });
});

/* ==========================================================================
   MY GARAGE: a persistent vehicle context.

   When a shopper picks a car anywhere (homepage picker, sidebar Vehicle group,
   mega menu, drawer), it is saved to localStorage. A compact chip then rides
   the header on every page. With a car saved, in site category and collection
   links are rewritten AT CLICK TIME (never in the DOM) to carry the vehicle
   tag, so a tap on Turbochargers lands on that car's turbochargers. Links that
   already name a vehicle, the store index, and pages whose own vehicle differs
   from the garage are left alone, so an explicit choice always wins.
   ========================================================================== */
(function () {
  'use strict';
  var BPF = window.BPF || {};
  if (!BPF.loadNav || !window.localStorage) return;

  var GKEY = 'bpf.garage';
  var hz = BPF.handleize;
  var BASE = BPF.collectionsBase || '/collections';

  function readGarage() {
    try {
      var o = JSON.parse(localStorage.getItem(GKEY));
      return (o && o.v === 1 && o.tagHandle) ? o : null;
    } catch (e) { return null; }
  }
  function writeGarage(g) {
    try { localStorage.setItem(GKEY, JSON.stringify(g)); } catch (e) {}
    render();
    window.dispatchEvent(new Event('bpf:garagechange'));
  }
  function clearGarage() {
    try { localStorage.removeItem(GKEY); } catch (e) {}
    render();
    window.dispatchEvent(new Event('bpf:garagechange'));
  }
  // exposed so the filter panel can keep clearing symmetric: an explicit clear
  // of the vehicle there drops the garage too, and repaints this chip at once
  window.BPF = window.BPF || {};
  window.BPF.clearGarage = clearGarage;
  function garageLabel(g) { return (g.makeName + ' ' + g.familyName).trim(); }
  function partsUrl(g) { return BPF.vehicleUrl ? BPF.vehicleUrl({ tag: g.tag, handle: g.handle }) : (BASE + '/all/' + g.tagHandle); }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  var CAR_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13"/><path d="M3 17v-2.2a2 2 0 0 1 1.2-1.8h15.6A2 2 0 0 1 21 14.8V17a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><circle cx="7.5" cy="14.5" r=".6"/><circle cx="16.5" cy="14.5" r=".6"/></svg>';
  var CHV_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  /* ---- vehicle lookups from the shared nav data ---- */
  var ready = false;
  var familyByHandle = {};   // family/generation collection handle -> vehicle
  var familyByTag = {};      // family/generation tag handle -> vehicle
  var vehicleHandleToTag = {}; // any vehicle collection handle -> its tag handle (makes too)
  var allVehicleTags = {};   // set of every vehicle tag handle (makes, families, generations)
  var navData = null;

  BPF.loadNav().then(function (d) {
    navData = d;
    (d.makes || []).forEach(function (mk) {
      var mkH = hz(mk.tag);
      vehicleHandleToTag[mk.handle] = mkH;
      allVehicleTags[mkH] = 1;
      (mk.families || []).forEach(function (f) {
        var v = { v: 1, makeName: mk.name, familyName: f.name, tag: f.tag, tagHandle: hz(f.tag), handle: f.handle };
        familyByHandle[f.handle] = v;
        familyByTag[v.tagHandle] = v;
        vehicleHandleToTag[f.handle] = v.tagHandle;
        allVehicleTags[v.tagHandle] = 1;
        (f.generations || []).forEach(function (g) {
          var gv = { v: 1, makeName: mk.name, familyName: f.name, tag: g.tag, tagHandle: hz(g.tag), handle: g.handle, generation: (g.display || g.code || '') };
          familyByHandle[g.handle] = gv;
          familyByTag[gv.tagHandle] = gv;
          vehicleHandleToTag[g.handle] = gv.tagHandle;
          allVehicleTags[gv.tagHandle] = 1;
        });
      });
    });
    ready = true;
    render();
  }).catch(function () {});

  function parsePath(pathname) {
    // a within: product link (/collections/<handle>/products/<handle>) is a
    // product page, not a collection to refine or rewrite: never misread its
    // trailing segments as a tag list. This keeps the garage rewriter, the
    // auto-save, and pageVehicle off product URLs.
    if (pathname.indexOf('/products/') >= 0) return null;
    var segs = pathname.replace(/^\/+/, '').replace(/\/+$/, '').split('/');
    if (segs[0] !== 'collections' || !segs[1]) return null;
    return {
      handle: segs[1],
      tags: segs[2] ? decodeURIComponent(segs[2]).split('+').filter(Boolean) : []
    };
  }

  // the most specific family/generation a link points at, for auto saving
  function familyForHref(href) {
    var u; try { u = new URL(href, location.origin); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    var p = parsePath(u.pathname);
    if (!p) return null;
    if (familyByHandle[p.handle]) return familyByHandle[p.handle];
    for (var i = 0; i < p.tags.length; i++) {
      if (familyByTag[p.tags[i]]) return familyByTag[p.tags[i]];
    }
    return null;
  }

  // the vehicle the current page is scoped to, if any (tag handle)
  function pageVehicle() {
    var panel = document.querySelector('[data-filter-panel]');
    if (panel) {
      var h = panel.getAttribute('data-collection-handle');
      if (vehicleHandleToTag[h]) return vehicleHandleToTag[h];
      var tags = (panel.getAttribute('data-current-tags') || '').split('~').filter(Boolean).map(hz);
      for (var i = 0; i < tags.length; i++) { if (allVehicleTags[tags[i]]) return tags[i]; }
      return null;
    }
    var p = parsePath(location.pathname);
    if (!p) return null;
    if (vehicleHandleToTag[p.handle]) return vehicleHandleToTag[p.handle];
    for (var j = 0; j < p.tags.length; j++) { if (allVehicleTags[p.tags[j]]) return p.tags[j]; }
    return null;
  }

  /* ---- auto save: picking any family or generation link records the car ---- */
  document.addEventListener('click', function (e) {
    if (!ready) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var v = familyForHref(a.getAttribute('href'));
    if (!v) return;
    var cur = readGarage();
    if (cur && cur.tagHandle === v.tagHandle) return; // already set
    writeGarage(v);
  });

  /* ---- link rewrite: carry the saved car onto plain collection links ----
     At click time only, so the DOM keeps clean crawlable hrefs. */
  document.addEventListener('click', function (e) {
    if (!ready) return;
    if (e.defaultPrevented) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var g = readGarage();
    if (!g) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.hasAttribute('data-no-garage')) return;
    // the collection filter panel and pagination are owned by the refine engine
    if (a.closest('[data-filter-panel]') || a.closest('.pagination') || a.closest('[data-swap="results"]')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var u; try { u = new URL(href, location.origin); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    var p = parsePath(u.pathname);
    if (!p) return;                             // not a specific collection (store index included)
    if (vehicleHandleToTag[p.handle]) return;   // already a vehicle collection
    if (p.tags.some(function (h) { return allVehicleTags[h]; })) return; // already carries a vehicle tag
    var pv = pageVehicle();
    if (pv && pv !== g.tagHandle) return;       // page has a different explicit car: respect it
    var newUrl;
    if (p.handle === 'all' && p.tags.length === 0 && g.handle) {
      // bare /collections/all: send it to the garage vehicle's dedicated
      // collection (the canonical per-vehicle surface) rather than /all/<tag>.
      // u.search already carries the in stock default when the capture-phase
      // injection mutated this href before we read it.
      newUrl = '/collections/' + g.handle + (u.search || '') + (u.hash || '');
    } else {
      // a category (or other) collection: compose the garage tag onto it, sorted
      var tags = p.tags.concat(g.tagHandle).sort();
      newUrl = '/collections/' + p.handle + '/' + tags.join('+') + (u.search || '') + (u.hash || '');
    }
    e.preventDefault();
    window.location.href = newUrl;
  });

  /* ---- the header chip and its popover ---- */
  var slots = [].slice.call(document.querySelectorAll('[data-garage-slot]'));
  var openPop = null;
  var scrim = null; // backdrop behind the mobile sheet; CSS keeps it inert on desktop

  function closePop() {
    if (openPop) {
      openPop.classList.remove('is-open');
      var ob = openPop.parentNode ? openPop.parentNode.querySelector('.garage-chip') : null;
      if (ob) ob.setAttribute('aria-expanded', 'false');
      openPop = null;
    }
    if (scrim) { scrim.parentNode && scrim.parentNode.removeChild(scrim); scrim = null; }
    document.removeEventListener('click', outside, true);
  }
  function outside(e) {
    if (openPop && !openPop.parentNode.contains(e.target)) closePop();
  }

  function buildChangePicker(g, onSet) {
    var wrap = el('div', 'garage-change');
    var makeSel = el('select', 'garage-select');
    var modelSel = el('select', 'garage-select');
    modelSel.disabled = true;
    var setBtn = el('button', 'btn btn-primary garage-set', 'Set vehicle');
    setBtn.type = 'button';
    setBtn.disabled = true;

    function opt(v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t; return o; }
    makeSel.appendChild(opt('', 'Select make'));
    modelSel.appendChild(opt('', 'Select model'));
    if (!navData) { wrap.appendChild(el('p', 'garage-change-note', 'Loading vehicles')); return wrap; }

    var makes = BPF.alphabetical ? BPF.alphabetical(navData.makes) : navData.makes.map(function (m, i) { return { i: i, item: m }; });
    makes.forEach(function (m) { makeSel.appendChild(opt(String(m.i), m.item.name)); });
    // prefill make
    var preMakeIdx = -1;
    navData.makes.forEach(function (m, i) { if (m.name === g.makeName) preMakeIdx = i; });

    function fillModels(mkIdx, preFamName) {
      modelSel.textContent = '';
      modelSel.appendChild(opt('', 'Select model'));
      var mk = navData.makes[mkIdx];
      modelSel.disabled = !mk;
      if (!mk) return;
      var fams = BPF.alphabetical ? BPF.alphabetical(mk.families) : mk.families.map(function (f, i) { return { i: i, item: f }; });
      fams.forEach(function (f) {
        var o = opt(String(f.i), f.item.name);
        if (preFamName && f.item.name === preFamName) o.selected = true;
        modelSel.appendChild(o);
      });
      setBtn.disabled = modelSel.value === '';
    }
    if (preMakeIdx >= 0) { makeSel.value = String(preMakeIdx); fillModels(preMakeIdx, g.familyName); }

    makeSel.addEventListener('change', function () {
      setBtn.disabled = true;
      if (makeSel.value === '') { modelSel.textContent = ''; modelSel.appendChild(opt('', 'Select model')); modelSel.disabled = true; return; }
      fillModels(parseInt(makeSel.value, 10), null);
    });
    modelSel.addEventListener('change', function () { setBtn.disabled = modelSel.value === ''; });
    setBtn.addEventListener('click', function () {
      var mk = navData.makes[parseInt(makeSel.value, 10)];
      var fam = mk && mk.families[parseInt(modelSel.value, 10)];
      if (!fam) return;
      onSet({ v: 1, makeName: mk.name, familyName: fam.name, tag: fam.tag, tagHandle: hz(fam.tag), handle: fam.handle });
    });

    wrap.appendChild(makeSel);
    wrap.appendChild(modelSel);
    wrap.appendChild(setBtn);
    return wrap;
  }

  function buildChip(g, which) {
    var host = el('div', 'garage' + (which === 'mobile' ? ' garage-mobile' : ' garage-desktop'));

    var btn = el('button', 'garage-chip');
    btn.type = 'button';
    btn.setAttribute('aria-haspopup', 'true');
    btn.setAttribute('aria-expanded', 'false');
    var icon = el('span', 'garage-chip-icon'); icon.innerHTML = CAR_SVG;
    var lbl = el('span', 'garage-chip-label', garageLabel(g));
    var chv = el('span', 'garage-chip-chev'); chv.innerHTML = CHV_SVG;
    btn.appendChild(icon); btn.appendChild(lbl); btn.appendChild(chv);

    var pop = el('div', 'garage-pop');
    pop.appendChild(el('p', 'garage-pop-eyebrow', 'Your vehicle'));
    pop.appendChild(el('p', 'garage-pop-car', garageLabel(g)));
    var partsLink = el('a', 'garage-pop-parts', 'Parts for your car');
    partsLink.href = partsUrl(g);
    pop.appendChild(partsLink);

    var actions = el('div', 'garage-pop-actions');
    var changeBtn = el('button', 'garage-pop-btn', 'Change');
    changeBtn.type = 'button';
    var clearBtn = el('button', 'garage-pop-btn garage-pop-clear', 'Clear');
    clearBtn.type = 'button';
    actions.appendChild(changeBtn);
    actions.appendChild(clearBtn);
    pop.appendChild(actions);

    var changeMount = el('div', 'garage-change-mount');
    changeMount.hidden = true;
    pop.appendChild(changeMount);

    changeBtn.addEventListener('click', function () {
      if (!changeMount.hidden) { changeMount.hidden = true; changeMount.textContent = ''; return; }
      changeMount.textContent = '';
      changeMount.appendChild(buildChangePicker(g, function (nv) {
        writeGarage(nv);
        window.location.href = partsUrl(nv);
      }));
      changeMount.hidden = false;
    });
    clearBtn.addEventListener('click', function () { clearGarage(); closePop(); });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = pop.classList.contains('is-open');
      closePop();
      if (!isOpen) {
        scrim = el('div', 'garage-scrim');
        document.body.appendChild(scrim);
        pop.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        openPop = pop;
        setTimeout(function () { document.addEventListener('click', outside, true); }, 0);
      } else {
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    host.appendChild(btn);
    host.appendChild(pop);
    return host;
  }

  /* Garage-aware breadcrumb augmentation. New rule: the vehicle context always
     AUGMENTS the trail, never competes with the category. Where the shopper's car
     fits this product the crumb reads HOME / <category> / <car> / <product>, with
     the car linking the composed category+vehicle view, so the category the
     shopper browsed stays visible and the car is added beside it (this replaces
     the old behavior where the garage crumb REPLACED the category).

     Every product page now carries data-product-tags, so this runs on the
     collection-context crumb too, not just the no-context one. The pristine server
     HTML is captured once and re-rendered from every time, so this is idempotent
     (no duplicate segments) and a garage clear or switch restores cleanly.

     Vehicle context resolution:
       1. the click-time referrer context (sessionStorage bpf.pdpctx) when its p
          matches this pathname: use its veh/vehLabel. veh null there means the
          referrer explicitly had no vehicle, but we still fall through to the
          garage so the trail augments whenever the saved car fits.
       2. else the saved garage: veh = tagHandle, label = make + family.
     The vehicle only renders when its handle is in data-product-tags (it actually
     fits). Cases:
       a/c. a category crumb exists (collection context, or the honest no-context
            category default) and it is NOT a vehicle collection: append the
            vehicle crumb after it, linking /collections/<category>/<vehHandle>.
       b.   the crumb IS a vehicle collection (came from a dedicated one like
            audi-r8-parts): no augmentation, the crumb already is the car.
       d.   no collection crumb at all (garage path only, since a ctx referrer
            implies a collection existed): insert a single crumb to the car's
            dedicated collection, labelled "<make> <family> Parts".
     The appended vehicle link is a BARE composed URL with no availability param:
     the availability injector is scoped to collection pages (it does not run on a
     product page), and the composed collection view self-applies the in-stock
     default on first paint with replace semantics, so the engine's param rules are
     preserved without us guessing the param here. */
  var crumbOriginal = null;
  function readPdpCtx() {
    try {
      var c = JSON.parse(sessionStorage.getItem('bpf.pdpctx'));
      if (c && c.p === location.pathname) return c;
    } catch (e) {}
    return null;
  }
  function lastSeg(href) {
    var path = href || '';
    try { path = new URL(href, location.origin).pathname; } catch (e) {}
    var segs = path.replace(/^\/+/, '').replace(/\/+$/, '').split('/');
    return segs[segs.length - 1] || '';
  }
  // append a vehicle crumb (link + the same "/" separator the crumb uses) after
  // the category crumb, before the product title span
  function appendVehicleCrumb(nav, url, label) {
    var a = el('a', null, label);
    a.setAttribute('href', url);
    var cur = nav.querySelector('[aria-current="page"]');
    nav.insertBefore(a, cur);
    nav.insertBefore(el('span', null, '/'), cur);
  }
  function upgradeBreadcrumb() {
    var nav = document.querySelector('nav.breadcrumb[data-product-tags]');
    if (!nav) return;
    if (crumbOriginal === null) crumbOriginal = nav.innerHTML;
    nav.innerHTML = crumbOriginal; // start from the pristine server crumb every render

    var tags = (nav.getAttribute('data-product-tags') || '').split(/\s+/).filter(Boolean);
    var ctx = readPdpCtx();
    var g = readGarage();

    // resolve the candidate vehicle
    var vehHandle = null, vehLabel = null;
    if (ctx && ctx.veh) {
      vehHandle = ctx.veh;
      vehLabel = ctx.vehLabel || null;
    } else if (g && g.tagHandle) {
      vehHandle = g.tagHandle;
      vehLabel = (g.makeName + ' ' + g.familyName).replace(/\s+/g, ' ').trim();
    }
    var fits = !!(vehHandle && vehLabel && tags.indexOf(vehHandle) >= 0);

    var link = nav.querySelector('[data-crumb-collection]');
    if (link) {
      // is the existing crumb a dedicated vehicle collection? (its handle ends in
      // -parts, or the matched click context said the referring collection was a
      // vehicle collection)
      var linkIsVehicle = /-parts$/.test(lastSeg(link.getAttribute('href'))) || !!(ctx && ctx.collIsVehicle);
      if (linkIsVehicle) return;                 // case b: the crumb already is the car
      if (!fits) return;                         // the car does not fit: honest category crumb stands
      // case a / c: augment after the category crumb
      var categoryHandle = lastSeg(link.getAttribute('href'));
      appendVehicleCrumb(nav, BASE + '/' + categoryHandle + '/' + vehHandle, vehLabel);
      return;
    }
    // case d: no collection crumb at all (garage path only). Insert a single crumb
    // to the car's dedicated collection.
    if (!g || !g.handle || !g.tagHandle || tags.indexOf(g.tagHandle) < 0) return;
    var dedLabel = (g.makeName + ' ' + g.familyName).replace(/\s+/g, ' ').trim() + ' Parts';
    var a = el('a', null, dedLabel);
    a.setAttribute('href', BASE + '/' + g.handle);
    a.setAttribute('data-crumb-collection', '');
    var cur0 = nav.querySelector('[aria-current="page"]');
    nav.insertBefore(a, cur0);
    nav.insertBefore(el('span', null, '/'), cur0);
  }

  function render() {
    upgradeBreadcrumb(); // keep the product crumb in step with the garage
    var g = readGarage();
    slots.forEach(function (slot) {
      slot.textContent = '';
      if (!g) { slot.hidden = true; return; }
      slot.hidden = false;
      slot.appendChild(buildChip(g, slot.getAttribute('data-garage-slot')));
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  render(); // paint immediately from storage; nav lookups fill in when ready
})();

/* ==========================================================================
   PREDICTIVE SEARCH: a search-as-you-type dropdown over /search/suggest.json.

   Generic over every [data-predictive-search] box (desktop masthead, mobile
   search bar, the search and 404 page forms). Each box keeps its own input,
   panel, request sequence and AbortController; the results cache is shared.
   Progressive enhancement only: with no fetch the form stays a plain GET to
   /search, and every ARIA hook is added here rather than in the markup.

   Response shape: resources.results.{queries,collections,products}. Prices are
   dollars as decimals (885.99), not cents. Query rows are highlighted from the
   plain `text`, never the server styled_text, so nothing untrusted is injected.
   ========================================================================== */
(function () {
  'use strict';

  var boxes = document.querySelectorAll('[data-predictive-search]');
  if (!boxes.length || !window.fetch || !window.AbortController) return;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 250;
  var MAX_QUERIES = 4;
  var MAX_COLLECTIONS = 5;
  var MAX_PRODUCTS = 6;
  var CACHE_CAP = 20;

  /* ---- shared results cache: term -> results, FIFO capped ---- */
  var cache = {};
  var cacheOrder = [];
  function cacheGet(key) {
    return Object.prototype.hasOwnProperty.call(cache, key) ? cache[key] : null;
  }
  function cachePut(key, results) {
    if (!Object.prototype.hasOwnProperty.call(cache, key)) {
      cacheOrder.push(key);
      if (cacheOrder.length > CACHE_CAP) { delete cache[cacheOrder.shift()]; }
    }
    cache[key] = results;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function suggestUrl(term) {
    return '/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=product,collection,query'
      + '&resources[limit]=6&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=hide';
  }

  /* Query URLs already carry the analytics params (_pos/_psq/_psid/_ss); keep
     them, and add type=product so the results land on the product template. */
  function withType(href) {
    return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'type=product';
  }

  /* Build the highlight from the plain text with textContent, so a <mark> only
     ever wraps a literal slice of the suggestion and no markup is injected. */
  function highlightInto(node, text, term) {
    var low = text.toLowerCase();
    var needle = term.toLowerCase();
    var from = 0;
    if (!needle) { node.appendChild(document.createTextNode(text)); return; }
    var at = low.indexOf(needle, from);
    while (at !== -1) {
      if (at > from) node.appendChild(document.createTextNode(text.slice(from, at)));
      node.appendChild(el('mark', null, text.slice(at, at + needle.length)));
      from = at + needle.length;
      at = low.indexOf(needle, from);
    }
    if (from < text.length) node.appendChild(document.createTextNode(text.slice(from)));
  }

  /* ---- one box ---- */
  function initBox(wrapper, index) {
    var form = wrapper.querySelector('form.search-form') || wrapper.querySelector('form');
    var input = wrapper.querySelector('input[type="search"]');
    if (!form || !input) return;

    var panelId = 'ps-panel-' + index;
    var panel = el('div', 'ps-panel');
    panel.id = panelId;
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    // sibling of the form, never a child: .search-form clips overflow
    wrapper.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', panelId);

    var options = [];       // every [role=option] in DOM order
    var activeIndex = -1;
    var isOpen = false;
    var term = '';          // the term the panel is currently showing
    var controller = null;
    var seq = 0;            // monotonic per box: drop any response older than this
    var timer = null;

    /* ---- row builders ---- */
    function queryRow(q) {
      var a = el('a', 'ps-row ps-row-q');
      a.href = withType(q.url || ('/search?q=' + encodeURIComponent(q.text)));
      a.setAttribute('role', 'option');
      var span = el('span', 'ps-q-text');
      highlightInto(span, q.text || '', term);
      a.appendChild(span);
      return a;
    }
    function collectionRow(c) {
      var a = el('a', 'ps-row ps-row-c');
      a.href = c.url;
      a.setAttribute('role', 'option');
      a.appendChild(el('span', 'ps-c-text', c.title || ''));
      return a;
    }
    function priceBlock(p) {
      var min = p.price_min != null ? p.price_min : p.price;
      if (min == null) return null;
      var div = el('div', 'price ps-price');
      div.appendChild(el('span', 'price-now', money(min)));
      var cmp = p.compare_at_price_min;
      if (cmp != null && Number(cmp) > Number(min)) {
        div.appendChild(el('s', 'price-was', money(cmp)));
      }
      return div;
    }
    function productRow(p) {
      var a = el('a', 'ps-row ps-row-p');
      a.href = p.url;
      a.setAttribute('role', 'option');
      var thumb = el('span', 'ps-thumb');
      var src = p.featured_image && p.featured_image.url;
      if (src) {
        var img = document.createElement('img');
        img.src = src + '&width=120';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 44;
        img.height = 44;
        thumb.appendChild(img);
      }
      a.appendChild(thumb);
      var body = el('span', 'ps-p-body');
      body.appendChild(el('span', 'ps-p-title', p.title || ''));
      var price = priceBlock(p);
      if (price) body.appendChild(price);
      a.appendChild(body);
      return a;
    }
    function footRow(t) {
      var a = el('a', 'ps-row ps-foot');
      a.href = '/search?q=' + encodeURIComponent(t) + '&type=product';
      a.setAttribute('role', 'option');
      a.appendChild(document.createTextNode('Search for '));
      a.appendChild(el('span', 'ps-foot-q', '"' + t + '"'));
      return a;
    }
    function addSection(title, items, builder) {
      var head = el('div', 'ps-eyebrow', title);
      head.setAttribute('aria-hidden', 'true');
      panel.appendChild(head);
      var list = el('div', 'ps-list');
      var i;
      for (i = 0; i < items.length; i++) { list.appendChild(builder(items[i])); }
      panel.appendChild(list);
    }

    /* ---- render ---- */
    function render(results, displayTerm) {
      term = displayTerm;
      panel.textContent = '';
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');

      var queries = (results.queries || []).slice(0, MAX_QUERIES);
      var collections = (results.collections || []).slice(0, MAX_COLLECTIONS);
      var products = (results.products || []).slice(0, MAX_PRODUCTS);

      if (queries.length) addSection('Searches', queries, queryRow);
      if (collections.length) addSection('Collections', collections, collectionRow);
      if (products.length) addSection('Products', products, productRow);
      if (!queries.length && !collections.length && !products.length) {
        panel.appendChild(el('div', 'ps-empty', 'No matches for "' + displayTerm + '"'));
      }
      panel.appendChild(footRow(displayTerm));

      options = [].slice.call(panel.querySelectorAll('[role="option"]'));
      var i;
      for (i = 0; i < options.length; i++) { options[i].id = panelId + '-opt-' + i; }
    }

    /* ---- open / close / loading ---- */
    function openPanel() {
      panel.hidden = false;
      isOpen = true;
      input.setAttribute('aria-expanded', 'true');
    }
    function clearActive() {
      var i;
      for (i = 0; i < options.length; i++) { options[i].classList.remove('is-active'); }
    }
    function closePanel() {
      if (timer) { clearTimeout(timer); timer = null; }
      panel.hidden = true;
      isOpen = false;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      panel.classList.remove('is-loading');
      clearActive();
    }
    function setLoading(on) {
      panel.classList.toggle('is-loading', !!on);
    }

    /* ---- fetch pipeline ---- */
    function runQuery(t) {
      var key = t.toLowerCase();
      var hit = cacheGet(key);
      if (hit) {
        render(hit, t);
        openPanel();
        setLoading(false);
        return;
      }
      if (controller) controller.abort();
      controller = new window.AbortController();
      var mySeq = ++seq;
      if (isOpen) setLoading(true);
      fetch(suggestUrl(t), {
        signal: controller.signal,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('suggest ' + r.status);
        return r.json();
      }).then(function (data) {
        if (mySeq !== seq) return; // a newer request has since gone out
        var results = (data && data.resources && data.resources.results) || {};
        cachePut(key, results);
        render(results, t);
        openPanel();
        setLoading(false);
        controller = null;
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (mySeq !== seq) return;
        setLoading(false);
      });
    }

    /* ---- keyboard highlight ---- */
    function move(dir) {
      if (!options.length) return;
      if (activeIndex >= 0) options[activeIndex].classList.remove('is-active');
      if (activeIndex === -1) activeIndex = dir > 0 ? 0 : options.length - 1;
      else activeIndex = (activeIndex + dir + options.length) % options.length;
      var opt = options[activeIndex];
      opt.classList.add('is-active');
      input.setAttribute('aria-activedescendant', opt.id);
      if (opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
    }

    /* ---- events ---- */
    input.addEventListener('input', function () {
      var t = input.value.trim();
      if (timer) { clearTimeout(timer); timer = null; }
      // abort any in-flight request on every keystroke, stale or not
      if (controller) { controller.abort(); controller = null; }
      if (t.length < MIN_CHARS) {
        seq++; // invalidate anything still pending
        term = '';
        closePanel();
        return;
      }
      timer = setTimeout(function () { runQuery(t); }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var t = input.value.trim();
      if (t.length < MIN_CHARS) return;
      var hit = cacheGet(t.toLowerCase());
      if (hit) { render(hit, t); openPanel(); }
      else runQuery(t);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        if (!isOpen || !options.length) return;
        e.preventDefault();
        move(1);
      } else if (e.key === 'ArrowUp') {
        if (!isOpen || !options.length) return;
        e.preventDefault();
        move(-1);
      } else if (e.key === 'Enter') {
        // with an active option, go there; with none, let the form submit natively
        if (isOpen && activeIndex >= 0 && options[activeIndex]) {
          e.preventDefault();
          window.location.href = options[activeIndex].href;
        }
      } else if (e.key === 'Escape') {
        if (isOpen) { e.preventDefault(); closePanel(); input.focus(); }
      } else if (e.key === 'Tab') {
        if (isOpen) closePanel();
      }
    });

    // click outside closes; never close on blur, or panel link clicks would die
    document.addEventListener('click', function (e) {
      if (isOpen && !wrapper.contains(e.target)) closePanel();
    });
  }

  var i;
  for (i = 0; i < boxes.length; i++) { initBox(boxes[i], i); }
})();
